// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BC-Page__MerchandisingV2 .BC-Filters {
  position: relative;
}

.BC-Page__MerchandisingV2 .BC-Filters .BC-Filters-ConnectedFilterControl {
  display: flex;
  flex-grow: 1;
  gap: 10px;
}

.BC-Page__MerchandisingV2 .BC-Filters .BC-Filters-ConnectedFilterControl__CenterContainer {
  min-width: 6.25rem;
  display: flex;
}

.BC-Page__MerchandisingV2 .BC-Filters .BC-Filters-ConnectedFilterControl__RightContainer {
  margin-left: 0.5rem;
  flex: 1 1 auto;
}

.BC-Page__MerchandisingV2 .BC-Filters .BC-Filters__TagsContainer {
  padding-top: 0.5rem;
}

.BC-Popover__MerchandisingV2-Filters-Options {
  min-width: 244px;
}

.BC-Popover__MerchandisingV2-Filters-Options .Polaris-ChoiceList ul {
  display: flex;
}

.BC-Popover__MerchandisingV2-Filters-Market .Polaris-ChoiceList ul {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 8px;
}

.BC-Page__MerchandisingV2 .Polaris-DataTable__Table .group_btn .Polaris-Button--plain svg {
  fill: var(--p-icon);
}

.BC-Popover__MerchandisingV2-Filters-Options .Polaris-ChoiceList ul li {
  margin-right: 1.25rem;
}

.BC-Popover__MerchandisingV2-Filters-EditColumn {
  min-width: 12rem;
}

.Polaris-Popover__Wrapper .Polaris-Popover__Section {
  padding: 20px;
}

.BC-Popover__MerchandisingV2-Filters-Options legend {
  margin-bottom: 12px;
}

.BC-Popover__MerchandisingV2-Filters-Options legend,
.BC-Popover__MerchandisingV2-Filters-Options .Polaris-Label__Text {
  font-weight: 500;
}

.BC-Page__MerchandisingV2 .Polaris-Card .Polaris-Card__Section .noRules {
  min-height: 370px;
}

.BC-Popover__MerchandisingV2-Filters-Options .breakLine,
.BC-Popover__MerchandisingV2-Filters-Market .breakLine {
  padding: 16px 0 0 0;
  display: flex;
  justify-content: space-between;
}

.BC-Popover__MerchandisingV2-Filters-Market .Polaris-Tag button {
  display: flex;
  align-items: center;
  margin: unset;
  text-align: right;
  justify-content: flex-end;
}

.BC-Popover__MerchandisingV2-Filters-Market {
  width: 210px;
}

.BC-Page__MerchandisingV2 .Polaris-DataTable__Cell {
  padding: 1rem 4px;
  white-space: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  vertical-align: middle;
}

.BC-Page__MerchandisingV2 .Polaris-DataTable__Table .Polaris-DataTable__Cell--ab-testing .disabled svg path {
  fill: #babec3;
}

.BC-Page__MerchandisingV2 .Polaris-DataTable__Cell--header {
  padding: 1rem 4px;
  font-weight: 500;
  border-bottom: 0.0625rem solid var(--p-divider);
}

.BC-Page__MerchandisingV2 .Polaris-DataTable__Cell--header p {
  font-weight: 500;
}

.BC-Page__MerchandisingV2 .Polaris-DataTable__Cell--header p,
.BC-Page__MerchandisingV2 .Polaris-DataTable__Cell> :first-child {
  font-size: 14px;
  line-height: 20px;
}

.Polaris-DataTable__Cell--consequences .Polaris-Icon--colorSubdued svg {
  fill: var(--p-icon-disabled);
}

.BC-Page__MerchandisingV2 .Polaris-DataTable__Cell.Polaris-DataTable__Cell--status {
  width: 6%;
  padding: 18px 18px 18px 20px;
}

.BC-Page__MerchandisingV2 .Polaris-DataTable__Cell.Polaris-DataTable__Cell--status span:hover {
  cursor: pointer;
}

.BC-Page__Merchandising .Polaris-DataTable__Cell.Polaris-DataTable__Cell--status .BC-Checkbox-Status {
  margin: 0;
}

.BC-Page__MerchandisingV2 .Polaris-DataTable__Cell--status-locked .BC-Checkbox-Status input:checked+span {
  background-color: var(--p-surface-neutral-disabled) !important;
  cursor: not-allowed;
}

.BC-Page__MerchandisingV2 .Polaris-DataTable__Cell--status-locked .BC-Checkbox-Status input:checked+span::before {
  background-color: var(--p-icon-disabled) !important;
}

.BC-Page__MerchandisingV2 .Polaris-DataTable__Cell.Polaris-DataTable__Cell--queries,
.BC-Page__MerchandisingV2 .Polaris-DataTable__Cell.Polaris-DataTable__Cell--queries-disabled,
.BC-Page__MerchandisingV2 .Polaris-DataTable__Cell.Polaris-DataTable__Cell--collections-disabled,
.BC-Page__MerchandisingV2 .Polaris-DataTable__Cell.Polaris-DataTable__Cell--collections {
  width: 26%;
}

.BC-Page__MerchandisingV2 .Polaris-DataTable__Cell.Polaris-DataTable__Cell--queries .locked-query,
.BC-Page__MerchandisingV2 .Polaris-DataTable__Cell.Polaris-DataTable__Cell--queries-disabled .locked-query,
.BC-Page__MerchandisingV2 .Polaris-DataTable__Cell.Polaris-DataTable__Cell--collections-disabled .locked-query,
.BC-Page__MerchandisingV2 .Polaris-DataTable__Cell.Polaris-DataTable__Cell--collections .locked-query {
  display: flex;
  gap: 2px;
}

.BC-Page__MerchandisingV2 .Polaris-DataTable__Cell.Polaris-DataTable__Cell--collections-disabled .Polaris-Link,
.BC-Page__MerchandisingV2 .Polaris-DataTable__Cell.Polaris-DataTable__Cell--queries-disabled .Polaris-Link {
  color: #202223;
}

.BC-Page__MerchandisingV2 .Polaris-DataTable__Cell.Polaris-DataTable__Cell--strategies {
  width: 20%;
}

.BC-Page__MerchandisingV2 tbody .Polaris-DataTable__Cell.Polaris-DataTable__Cell--strategies {
  width: 20%;
}

.BC-Page__MerchandisingV2 tbody .Polaris-DataTable__Cell.Polaris-DataTable__Cell--market {
  width: 18%;
}

.BC-Page__MerchandisingV2 .Polaris-DataTable__Cell.Polaris-DataTable__Cell--dateRange {
  width: 20%;
  padding: 24px 12px;
}

.Polaris-DataTable__Cell--strategies span .Polaris-Icon .icon-filter {
  margin-top: 2px;
}

.BC-Page__MerchandisingV2 .Polaris-DataTable__Cell.Polaris-DataTable__Cell--ab-testing {
  width: 20%;
}

.BC-Page__MerchandisingV2 .Polaris-DataTable__Cell.Polaris-DataTable__Cell--ab-testing>p,
.BC-Page__MerchandisingV2 .Polaris-DataTable__Cell.Polaris-DataTable__Cell--ab-testing>div {
  display: flex;
  justify-content: center;
}

.BC-Page__MerchandisingV2 .Polaris-DataTable__Cell.Polaris-DataTable__Cell--dateRange .Polaris-Badge {
  border-radius: 4px;
}

.BC-Page__MerchandisingV2 .Polaris-DataTable__Cell.Polaris-DataTable__Cell--actions {
  width: 14%;
  text-align: center;
  padding-right: 12px;
}

.BC-Page__MerchandisingV2 .Polaris-DataTable__Cell.Polaris-DataTable__Cell--actions .Polaris-ButtonGroup--segmented {
  justify-content: right;
}

.BC-Page__MerchandisingV2 .Polaris-DataTable__Cell.Polaris-DataTable__Cell--consequences .Polaris-Icon {
  width: 1rem;
  height: 1rem;
}

.BC-Page__MerchandisingV2 .Polaris-DataTable__Cell--strategies .Polaris-Icon--colorSubdued svg {
  fill: #babec3;
}

.BC-EmptyRules__MerchandisingV2 img,
.BC-EmptyRules__Metafield img,
.BC-EmptyRules__CustomRangeSlider img,
.BC-EmptyRules__CustomSorting img,
.BC-EmptyRules__Product-Visibility img {
  width: 50px;
}

.BC-EmptyRules__MerchandisingV2 {
  min-height: 250px;
}

.BC-Page__Merchandising-FilterBar-ActiveDate {
  color: var(--p-text-subdued);
  font-weight: 400;
}

.BC-Page__MerchandisingV2-Rule .tooltip-highlight {
  border-radius: 10px;
  background-color: #a4e8f2;
  padding: 0 5px 0 5px;
}

.BC-Page__MerchandisingV2-Rule .fullscreen-title {
  display: flex;
  justify-content: center;
  flex-grow: 1;
  margin-left: 300px;
}

/* Region: Merchandising rule */
.BC-Page__MerchandisingV2-Rule .fullscreen-bar {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-left: 1rem;
  padding-right: 1rem;
}

.BC-Page__MerchandisingV2-Rule .merchandising-rule-strategy,
.BC-Page__MerchandisingV2-Rule .merchandising-rule-body .merchandising-rule-settings {
  /* isolation: isolate; */
  width: 30%;
  min-height: 980px;
  background: #ffffff;
  border: 1px solid #e1e3e5;
  border-bottom-left-radius: var(--p-border-radius-2);
  border-bottom-right-radius: var(--p-border-radius-2);
}

.BC-Page__MerchandisingV2-Rule .merchandising-rule-strategy>div {
  min-height: 1000px;
}

.BC-Page__MerchandisingV2-Rule .Polaris-FullscreenBar {
  position: fixed;
  width: 100%;
  top: 0;
}

.BC-Page__MerchandisingV2-Rule .merchandising-rule-body {
  display: flex;
  justify-content: space-between;
  margin-top: 3.5rem;
}

.BC-Page__MerchandisingV2-Rule .merchandising-rule-body .merchandising-rule-strategy .strategy-content {
  margin: 0 10px;
}

.BC-Page__MerchandisingV2-Rule .merchandising-rule-body .merchandising-rule-strategy .strategy-content .card-section {
  padding: 0px 20px 5px 0px;
  width: 100%;
}

.merchandising-rule-body .merchandising-rule-strategy .strategy-content .BC-Toggle-Switch {
  padding: 9px;
}

.merchandising-rule-body .merchandising-rule-strategy .strategy-content .Polaris-Banner {
  margin: 9px;

  padding: 8px 12px;
}

.BC-Page__MerchandisingV2-Rule .merchandising-rule-body .merchandising-rule-strategy .card-section,
.BC-Page__MerchandisingV2-Rule .merchandising-rule-body .merchandising-rule-settings .card-section {
  padding: 16px 20px 4px 20px;
}

.BC-Page__MerchandisingV2-Rule .merchandising-rule-body .merchandising-rule-strategy .card-banner-section {
  padding: 16px 12px 4px 12px;
}

.BC-Page__MerchandisingV2-Rule .merchandising-rule-body .merchandising-rule-strategy .card-banner-section>div>div {
  display: grid;
  gap: 20px;
}

.BC-Page__MerchandisingV2-Rule .banner-group-settings .banner-title {
  margin-top: 0px;
  margin-bottom: 8px;
  display: flex;
  justify-content: space-between;
}

.BC-Page__MerchandisingV2-Rule .merchandising-rule-body .merchandising-rule-settings .market .market-note {
  margin-top: 10px;
  color: #6d7175;
  margin-left: 20px;
}

.BC-Page__MerchandisingV2-Rule .merchandising-rule-body .merchandising-rule-settings .market .market-note .Polaris-Icon {
  display: inline-flex;
  vertical-align: top;
}

.BC-Page__MerchandisingV2-Rule .merchandising-rule-settings .set-rule-conditions .market .Polaris-Button {
  width: 100%;
}

.BC-Page__MerchandisingV2-Rule .merchandising-rule-settings .set-rule-conditions .market .Polaris-Button__Content {
  display: flex;
  justify-content: space-between;
  font-weight: 400;
}

.BC-Page__MerchandisingV2-Rule .banner-group-settings .banner-title .title {
  display: flex;
  gap: 3px;
  font-size: 12px;
  font-weight: 500;
  color: #6d7175;
}

.BC-Page__MerchandisingV2-Rule .banner-group-settings .banner-settings {
  padding: 12px;
  border-radius: 8px;
  background-color: #f6f6f7;
}

.BC-Page__MerchandisingV2-Rule .banner-group-settings .banner-image .Polaris-Link {
  display: flex;
  font-size: 14px;
  line-height: 20px;
  align-items: center;
  margin-top: 5px;
}

.BC-Page__MerchandisingV2-Rule .banner-group-settings .banner-image .Polaris-Link .Polaris-Icon {
  margin: unset;
}

.BC-Page__MerchandisingV2-Rule .banner-group-settings .banner-settings>div:not(:first-child) {
  margin-top: 16px;
}

.BC-Page__MerchandisingV2-Rule .banner-group-settings .banner-image>p:last-child {
  font-size: 12px;
  line-height: 16px;
  margin-top: 5px;
  color: #6d7175;
}

.custom-dropzone-merchandising {
  position: relative;
}

.custom-dropzone-merchandising .dropzone-content {
  background: #e5effd;
  padding: 4px 6px;
  font-size: 12px;
  font-weight: 600;
  color: #1f5199;
  width: fit-content;
  border-radius: 4px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 8px;
}

.custom-dropzone-merchandising .dropzone-image .image {
  display: flex;
  align-items: center;
  gap: 8px;
}

.custom-dropzone-merchandising button {
  padding: unset;
  width: 20px;
  height: 20px;
  position: absolute;
  right: 8px;
  top: 18px;
}

.custom-dropzone-merchandising .dropzone-image {
  padding: 18px 8px;
  display: flex;
  justify-content: space-between;
}

.custom-dropzone-merchandising .dropzone-image .file-info {
  display: grid;
  gap: 3px;
}

.custom-dropzone-merchandising .dropzone-image .Polaris-Caption {
  font-size: 12px;
  color: #6d7175;
  line-height: 16px;
}

.custom-dropzone-merchandising .dropzone-image .Polaris-Thumbnail>* {
  max-height: unset;
  height: auto;
  width: auto;
}

.custom-dropzone-merchandising .Polaris-TextStyle--variationSubdued {
  font-size: 12px;
}

.custom-dropzone-merchandising.uploaded-error .Polaris-DropZone {
  color: #d82c0d;
  size: 12px;
  font-weight: 600;
  min-height: 76px;
  align-items: center;
  background-color: #fff4f4;
}

.custom-dropzone-merchandising.uploaded-error .Polaris-DropZone--hasOutline:not(.Polaris-DropZone--isDisabled),
.custom-dropzone-merchandising.uploaded-error .Polaris-DropZone--hasOutline:not(.Polaris-DropZone--isDisabled):hover::after {
  border-color: #fd5749;
}

.custom-dropzone-merchandising.uploaded-error .Polaris-DropZone .dropzone-error {
  text-align: center;
  font-size: 12px;
}

.custom-dropzone-merchandising.uploaded-error .Polaris-DropZone .dropzone-error>p:first-child {
  font-weight: 600;
}

.custom-dropzone-merchandising.uploaded-error .Polaris-DropZone .dropzone-error>p:last-child {
  font-weight: 400 !important;
}

.BC-Page__MerchandisingV2-Rule .merchandising-rule-body .merchandising-rule-settings .merchandising-strategies {
  border-top: 1px solid #e4e5e7;
  margin-top: 15px;
}

.BC-Page__MerchandisingV2-Rule .merchandising-rule-body .merchandising-rule-strategy .card-section:last-child,
.BC-Page__MerchandisingV2-Rule .merchandising-rule-body .merchandising-rule-settings .card-section:last-child {
  box-shadow: unset;
}

.BC-Page__MerchandisingV2-Rule .merchandising-rule-body .merchandising-rule-settings .card-section>p {
  color: #6d7175;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  margin-top: 2px;
  margin-bottom: 1px;
}

.BC-Page__MerchandisingV2-Rule .merchandising-rule-body .merchandising-rule-strategy .wrap-attribute {
  display: flex;
}

.BC-Page__MerchandisingV2-Rule .merchandising-rule-body .merchandising-rule-strategy .last-or-connector {
  border-bottom: 1px solid #a4e8f2;
  margin-bottom: 30px;
}

.BC-Page__MerchandisingV2-Rule .merchandising-rule-body .merchandising-rule-strategy .or-text .Polaris-TextStyle--variationStrong {
  height: 20px;
  padding-left: 5px;
  padding-right: 5px;
  border-radius: 10px;
  background-color: #a4e8f2;
}

.BC-Page__MerchandisingV2-Rule .merchandising-rule-body .merchandising-rule-strategy .group-number {
  width: auto;
  min-width: 20px;
  height: 20px;
  border-radius: 4px;
  border: 1px solid rgba(201, 204, 207, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 5px;
  font-size: 12px;
  color: rgba(109, 113, 117, 1);
  line-height: 16px;
  font-weight: 500;
}

.BC-Page__MerchandisingV2-Rule .merchandising-rule-body .merchandising-rule-strategy .or-connector {
  width: 10px;
  margin-left: 10px;
  border-left: 1px solid #a4e8f2;
}

.BC-Page__MerchandisingV2-Rule .merchandising-rule-body .merchandising-rule-strategy .wrap-attribute .first-connector {
  border-top: 1px solid #a4e8f2;
  margin-top: 15px;
}

.BC-Page__MerchandisingV2-Rule .merchandising-rule-body .merchandising-rule-strategy .card-add-field-attribute .or-connector {
  border-bottom: 1px solid #a4e8f2;
  margin-bottom: 20px;
}

.BC-Page__MerchandisingV2-Rule .merchandising-rule-settings .set-rule-conditions>div,
.BC-Page__MerchandisingV2-Rule .merchandising-rule-settings .set-rule-conditions>div {
  padding-top: 16px;
}

.BC-Page__MerchandisingV2-Rule .merchandising-rule-settings .set-rule-conditions .date-range {
  display: flex;
  align-items: end;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
}

.BC-Page__MerchandisingV2-Rule .merchandising-rule-settings .set-rule-conditions .date-range>div {
  width: 50%;
}

.BC-Page__MerchandisingV2-Rule .merchandising-rule-settings .set-rule-conditions .default-text-style {
  font-weight: 400 !important;
}

.BC-Page__MerchandisingV2-Rule
  .merchandising-rule-settings
  .set-rule-conditions
  .premium-badge-crown,
.BC-SelectMarketType-item .premium-badge-crown {
  display: flex;
  gap: 4px;
}

.BC-Page__MerchandisingV2-Rule
  .merchandising-rule-settings
  .set-rule-conditions
  .premium-badge-crown
  .Polaris-Badge,
.BC-SelectMarketType-item .premium-badge-crown .Polaris-Badge {
  background-color: #fff2d9;
  border-radius: 4px;
  padding: 3px 4px;
}

.BC-SelectMarketType-item .premium-badge-crown .Polaris-Badge > span,
.set-rule-conditions .premium-badge-crown .Polaris-Badge > span {
  display: flex;
  align-items: center;
  gap: 4px;
}

.BC-SelectMarketType-item .Polaris-Link {
  display: flex;
  align-items: center;
}

.merchandising-rule-settings .set-rule-conditions .upgrade-plan-text .Polaris-Icon {
  vertical-align: top;
  display: inline-flex;
}

.merchandising-rule-settings .set-rule-conditions .Polaris-FormLayout__Item:has(.upgrade-plan-text) {
  margin-top: 4px;
}

.BC-Page__MerchandisingV2-Rule .merchandising-rule-settings .set-rule-conditions .premium-badge-crown .Polaris-Badge img {
  width: 14px;
  height: auto;
}

.BC-Page__MerchandisingV2-Rule .merchandising-rule-body .set-rule-strategies-title .Polaris-Icon {
  height: 0.8rem;
  width: 0.8rem;
  margin-top: 3px;
}

.BC-Page__MerchandisingV2-Rule .merchandising-rule-body .summary-title .title {
  margin-left: 20px;
}

.BC-Page__MerchandisingV2-Rule .merchandising-rule-body .summary-title {
  padding-top: 20px;
  margin-left: -20px;
  margin-right: -20px;
  border-top: solid 1px #e4e5e7;
}

.BC-Page__MerchandisingV2-Rule .merchandising-rule-body .set-rule-strategies-title .title {
  font-weight: 600;
  color: #6d7175;
}

.BC-Page__MerchandisingV2-Rule .merchandising-rule-body .set-rule-strategies-title {
  display: flex;
  gap: 10px;
  font-weight: 400;
  font-size: 14px;
  align-items: center;
}

.path-setup {
  color: #2c6ecb;
  text-decoration: underline;
  cursor: pointer;
}

.path-setup:hover {
  text-decoration: underline;
  cursor: pointer;
}

.set-rule-conditions div ul li {
  padding-top: 12px;
}

.BC-Page__MerchandisingV2-Rule .merchandising-rule-body .merchandising-rule-settings .title-bold-normal {
  height: 56px;
  display: flex;
  align-items: center !important;
}

.BC-Page__MerchandisingV2-Rule .merchandising-rule-preview {
  width: 50%;
  padding: 15px 15px 0 15px;
}

.BC-Page__MerchandisingV2-Rule .merchandising-rule-preview .Polaris-Card {
  height: 100%;
}

.BC-Page__MerchandisingV2-Rule .merchandising-rule-preview .Polaris-Card .Polaris-Card__Header {
  padding: 24px 0;
  border-bottom: 1px solid #f5f5f5;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.BC-Page__MerchandisingV2-Rule .merchandising-rule-preview .Polaris-Card .Polaris-Card__Header>div {
  width: 100%;
  padding: 0 54px;
  text-align: center;
}

.merchandising-rule-preview .Polaris-Card .Polaris-Card__Header .preview-title {
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
  margin-bottom: 4px;
}

.merchandising-rule-preview .Polaris-Card .Polaris-Card__Header .preview-content {
  color: #6D7175;
}

.merchandising-rule-preview .Polaris-Card .Polaris-Card__Header .preview-content-market {
  display: inline-flex;
  gap: 4px;
  align-items: center;
}

.merchandising-rule-preview .Polaris-Card .Polaris-Card__Header .preview-option {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 8px;
}

.merchandising-rule-preview .Polaris-Card .Polaris-Card__Header .preview-option .Polaris-Select {
  width: 204px;
}

.merchandising-rule-preview .Polaris-Card .Polaris-Card__Header .preview-option .preview-market div,
.merchandising-rule-preview .Polaris-Card .Polaris-Card__Header .preview-option>div {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  text-align: start;
}

.merchandising-rule-preview .Polaris-Card .Polaris-Card__Header .preview-option .preview-market .Polaris-SkeletonDisplayText__DisplayText{
  width: 100%;
}

.merchandising-rule-preview .Polaris-Card .Polaris-Card__Header .preview-content-market img {
  width: 20px;
  height: 20px;
}

.BC-Page__MerchandisingV2-Rule .merchandising-rule-preview .Polaris-Card .Polaris-Card__Header .Polaris-Heading {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: inset 0px -1px 0px #f5f5f5;
}

.BC-Page__MerchandisingV2-Rule .merchandising-rule-preview .Polaris-Card .Polaris-Card__Section {
  padding: 0 54px;
}

.merchandising-rule-preview .bannerItem .Polaris-Thumbnail {
  width: 100%;
  height: 100%;
  border: unset;
}

.merchandising-rule-preview .bannerItem:hover {
  cursor: pointer;
}

.merchandising-rule-preview .bannerItem .Polaris-Thumbnail img {
  margin: 0;
  width: 100%;
  height: 100%;
}

.merchandising-rule-preview .preview .product-loading {
  margin-top: 54px;
}

.merchandising-rule-preview .preview .banner-status {
  margin-bottom: 24px;
}

.merchandising-rule-preview .preview .banner-status .Polaris-Banner {
  padding: 8px 16px;
}

.BC-Page__MerchandisingV2-Rule .tooltip {
  margin-left: 7px;
  margin-top: 3px;
  width: 10px;
}

.BC-Page__MerchandisingV2-Rule .tooltip .Polaris-Icon {
  width: 0.7rem;
  height: 0.7rem;
}

.BC-Page__MerchandisingV2-Rule .merchandising-rule-strategy .card-section:first-child {
  box-shadow: inset 0px -1px 0px #e1e3e5;
}

.BC-Page__MerchandisingV2-Rule .render-queries-field {
  display: flex;
  justify-content: space-between;
}

.BC-Page__MerchandisingV2-Rule .wrap-queries {
  margin-left: 10px;
}

.BC-Page__MerchandisingV2-Rule .wrap-select {
  margin-left: 10px;
  display: flex;
}

.BC-Page__MerchandisingV2-Rule .wrap-select>div:nth-child(2) {
  width: 100%;
  margin-top: 14px;
}

.BC-Page__MerchandisingV2-Rule .wrap-select .Polaris-Select-2 {
  margin-top: 0.75rem;
  width: 100%;
}

.BC-Page__MerchandisingV2-Rule .BC-Collection-List__Values .wrap-select {
  padding-top: 16px;
  margin-top: 0;
  position: relative;
}

.BC-Page__MerchandisingV2-Rule .BC-Collection-List__Values .wrap-select .Polaris-Select-2 {
  margin-top: 0;
  max-width: calc(100% - 38px);
  padding-left: 10px;
}

.BC-Page__MerchandisingV2-Rule .BC-Collection-List__Values .wrap-select.wrap-select--disabled .Polaris-Select-2 {
  max-width: 100%;
}

.BC-Page__MerchandisingV2-Rule .BC-Collection-List__Values .wrap-select .button {
  margin-left: 8px;
  display: inline-flex;
  align-items: flex-start;
  justify-content: center;
}

.BC-Page__MerchandisingV2-Rule .BC-Collection-List__Values .wrap-select .button .Polaris-Button {
  position: relative;
  top: 10px;
}

.BC-Page__MerchandisingV2-Rule .all-rule-note {
  margin-top: 4px;
  color: #6d7175;
}

.BC-Page__MerchandisingV2-Rule .border-connect-select {
  width: 10px;
  height: 2rem;
  border-bottom: 1px solid #c9cccf;
  border-left: 1px solid #c9cccf;
}

.BC-Page__MerchandisingV2-Rule .BC-Collection-List__Values .wrap-select .border-connect-select {
  position: absolute;
  top: 0;
  left: 0;
  height: 36px;
}


.BC-Page__MerchandisingV2-Rule .BC-Collection-List__Values .btn-add-collection {
  margin-top: 16px;
  margin-left: 20px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

.BC-Page__MerchandisingV2-Rule .textfield-with-prefix {
  margin-top: 0.75rem;
}

.BC-Page__MerchandisingV2-Rule .border-connect-input {
  width: 10px;
  height: 2rem;
  border-bottom: 1px solid #c9cccf;
}

.BC-Page__MerchandisingV2-Rule .wrap-input .render-queries-field:not(:last-child) {
  border-left: 1px solid #c9cccf;
}

.BC-Page__MerchandisingV2-Rule .wrap-input .render-queries-field:last-child .border-connect-input {
  border-left: 1px solid #c9cccf;
}

.BC-Page__MerchandisingV2 .typeAllIcon .Polaris-Icon__Svg {
  fill: #f48d32;
}

.BC-Page__MerchandisingV2 .typeAllIcon {
  display: flex;
  width: 0.8rem;
  height: 0.8rem;
}

.BC-Page__MerchandisingV2 .wrapTypeAllIcon {
  min-width: 2rem;
  height: 1.5rem;
  border-radius: 4px;
  background-color: #fff5ea;
  margin-left: 5px;
  display: flex;
  justify-content: center;
  padding: 2px 10px;
  align-items: center;
  gap: 2px;
  max-width: 77px;
}

.merchandising-date-picker-input .Polaris-TextField {
  max-height: 36px;
  height: auto;
}

.merchandising-date-picker-input .Polaris-TextField input {
  display: flex;
  align-items: center;
}

.merchandising-rule-settings .title-bold-normal {
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  padding: 20px 20px !important;
}

.merchandising-rule-strategy .title-bold-normal {
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  padding: unset !important;
}

.BC-Page__MerchandisingV2-Rule-DateRange {
  font-weight: normal;
  color: rgb(118, 118, 118);
}

.BC-Page__MerchandisingV2 .noRules .Polaris-DataTable__Cell:not(:first-child) {
  text-align: center;
}

.BC-Page__MerchandisingV2-Rule .Polaris-Layout,
.BC-Page__MerchandisingV2-Rule .Polaris-Layout .Polaris-Layout__Section,
.BC-Page__MerchandisingV2-Rule .Polaris-Layout__Section .Polaris-Card__Section .Polaris-FormLayout {
  margin-top: 0;
}

.BC-Page__MerchandisingV2-Rule .Polaris-Layout__Section--secondary .Polaris-Layout__Section .Polaris-Card__Section:first-child {
  margin-top: 20px;
}

.BC-Page__MerchandisingV2-Rule .Polaris-Layout__Section--secondary .Polaris-Layout__Section .Polaris-Card__Section {
  margin-top: 21px;
}

.BC-Page__MerchandisingV2 .condition-scope {
  margin-bottom: 0.25rem;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
}

.BC-MerchandisingV2__Attribute .Polaris-Labelled__LabelWrapper {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  margin-left: 10px;
}

.BC-MerchandisingV2__Attribute .Polaris-FormLayout .Polaris-FormLayout__Item:nth-child(2) {
  margin-top: unset;
}

.BC-Page__MerchandisingV2-Rule .Polaris-Page .Polaris-Page__Content .Polaris-Layout .Polaris-Layout__Section {
  height: 100%;
}

.BC-Page__MerchandisingV2-Rule .Polaris-Page .Polaris-Page__Content .Polaris-Layout .Polaris-Layout__Section .Polaris-Card .Polaris-Card__Header {
  height: 3.75rem;
  border-bottom: 1px solid rgb(233, 230, 230);
}

.BC-Page__MerchandisingV2-Rule .Polaris-Layout {
  grid-auto-rows: 1fr;
  align-items: stretch;
  min-height: 800px;
}

.BC-Page__MerchandisingV2-Rule .Polaris-Scrollable .Polaris-Layout,
.BC-Page__MerchandisingV2-Rule .setting-rule-layout .Polaris-Layout {
  display: block !important;
  min-height: unset;
}

.BC-Page__MerchandisingV2-Rule .Polaris-Scrollable .Polaris-Layout .Polaris-Layout__Section .Polaris-Card__Section .Polaris-Heading {
  font-size: 16px;
  line-height: 24px;
}

.BC-Page__MerchandisingV2-Rule .Polaris-Layout .Polaris-Layout__Section .Polaris-Card {
  height: 100%;
}

.BC-Page__MerchandisingV2-Rule .Polaris-Layout .Polaris-Layout__Section .Polaris-Card .Polaris-Layout .Polaris-Layout__Section .Polaris-Card__Section {
  padding: 0rem 1.25rem;
}

.BC-Page__MerchandisingV2-Rule .Polaris-Layout .Polaris-Layout__Section .Polaris-Card .Polaris-Card__Header .Polaris-Heading {
  font-size: 20px;
  font-weight: 400;
  line-height: 28px;
}

.BC-Page__MerchandisingV2-Rule .Polaris-Layout .Polaris-Layout__Section {
  width: 100%;
  height: inherit !important;
}

.BC-Page__MerchandisingV2-Rule .conditions,
.BC-Page__MerchandisingV2-Rule .conditions-detail {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.BC-Page__MerchandisingV2-Rule .condition-hover-all-content {
  margin: 0rem -0.625rem -0.625rem -0.625rem;
  padding: 0.625rem 0.625rem 0.625rem 0.625rem;
}

.BC-Page__MerchandisingV2-Rule .conditions-detail img {
  width: 1.375rem;
  height: 1.375rem;
  margin-right: 0.5rem;
}

.BC-Page__MerchandisingV2-Rule .conditions-detail .Title_page_applied {
  color: gray;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
}

.merchandising-condition-enable-search {
  margin-top: 5px;
  font-size: 14;
  font-weight: 400;
  max-width: 490px;
  color: #f2711c;
}

.tooltip-enable-collection-search .Polaris-Tooltip-TooltipOverlay {
  max-width: 254px;
}

.BC-Page__MerchandisingV2-Rule .conditions .strategy-btn {
  width: 48%;
  padding: 0;
  margin-top: 1rem;
}

.BC-Page__MerchandisingV2-Rule .conditions .strategy-btn button {
  width: 100%;
}

.BC-Page__MerchandisingV2-Rule .conditions .merchandising-lock-banner-btn button {
  background-color: #ffc96b;
  box-shadow: 0px -1px 0px 0px #00000033 inset;
  border: 0px;
}

.BC-Page__MerchandisingV2-Rule .conditions button .Polaris-Button__Text {
  gap: 4px;
  display: flex;
  align-items: center;
}

.BC-Page__MerchandisingV2-Rule .conditions .product-performance-ranking-btn {
  width: 100%;
}

.BC-Page__MerchandisingV2-Rule .conditions .Polaris-Button__Content,
.BC-Page__MerchandisingV2-Rule .Polaris-Layout .Polaris-FormLayout__Item .Polaris-Button__Content .Polaris-Button__Text {
  font-weight: 500;
  line-height: 20px;
  font-size: 14px;
}

.BC-Page__MerchandisingV2-Rule .conditions-detail p,
.BC-Page__MerchandisingV2-Rule .consequence-detail-content {
  font-size: 14px !important;
  line-height: 20px;
}

.BC-Page__MerchandisingV2-Rule .conditions-detail p span {
  font-weight: 600;
}

.BC-Page__MerchandisingV2-Rule .consequence-add-button {
  position: absolute;
  top: '1px';
  right: 0;
}

.BC-Page__MerchandisingV2-Rule .consequence-detail {
  margin: -0.625rem;
  padding: 0.625rem;
}

.BC-Page__MerchandisingV2-Rule .consequence-detail:hover {
  background-color: var(--p-surface-hovered);
  position: relative;
}

.BC-Page__MerchandisingV2-Rule .consequence-detail .consequence-detail-action {
  position: absolute;
  top: 0.625rem;
  right: 0.625rem;
  display: none;
}

.BC-Page__MerchandisingV2-Rule .consequence-detail .consequence-detail-action button {
  margin-left: -0.25rem;
}

.BC-Page__MerchandisingV2-Rule .consequence-detail:hover .consequence-detail-action {
  display: block;
}

.BC-Page__MerchandisingV2-Rule .tile-set-condition .tooltip .Polaris-Icon {
  border: 0 !important;
  padding: 2px !important;
}

.BC-Page__MerchandisingV2-Rule .tile-set-condition {
  display: flex;
  justify-content: space-between;
}

.BC-Page__MerchandisingV2-Rule .merchandising-rule-strategy .consequence-detail-title-tooltip .Polaris-Icon {
  height: 0.75rem;
  width: 0.75rem;
  margin-top: 4px;
}

.BC-Page__MerchandisingV2-Rule .merchandising-rule-strategy .consequence-detail-header .title-header {
  display: flex;
  align-items: center;
  gap: 4px;
}

.merchandising-rule-strategy .consequence-detail-header .title-header p {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  font-size: 16px;
  font-weight: 600;
  color: #6d7175;
  max-width: 228px;
}

.BC-Page__MerchandisingV2-Rule .merchandising-rule-strategy .consequence-detail-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px 16px 20px !important;
}

.BC-Page__MerchandisingV2-Rule .merchandising-rule-strategy .consequence-detail-title-tooltip {
  display: flex;
  gap: 10px;
}

.BC-Page__MerchandisingV2-Rule .merchandising-rule-settings .consequence-detail-title,
.BC-Page__MerchandisingV2-Rule .consequence-detail-title .title,
.BC-MerchandisingV2-Rule-save-modal .consequence-detail-title {
  display: inline-flex;
  gap: 4px;
}

.BC-Page__MerchandisingV2-Rule .merchandising-rule-strategy .card-section:nth-child(3) .consequence-detail-title {
  margin-top: 6px;
}

.BC-Page__MerchandisingV2-Rule .merchandising-rule-strategy .card-section .consequence-detail-title {
  margin-bottom: 14px;
  margin-top: 5px;
}

.merchandising-rule-settings .consequence-detail-title .Polaris-Icon svg,
.merchandising-rule-strategy .consequence-detail-title .title .Polaris-Icon svg {
  width: 100%;
  height: auto;
  position: relative;
}

.BC-Page__MerchandisingV2-Rule .merchandising-draggable .wrap-attribute .card-section {
  border: 1px solid rgba(225, 227, 229, 1);
  border-radius: 8px;
  padding: unset !important;
  margin: 8px 0;
}

.BC-Page__MerchandisingV2-Rule .merchandising-draggable .consequence-detail-title .drag-icon .Polaris-Icon {
  border: unset !important;
  margin-right: 8px !important;
}

.BC-Page__MerchandisingV2-Rule .merchandising-draggable .consequence-detail-title {
  border-bottom: 1px dashed rgba(225, 227, 229, 1);
  padding: 8px;
  margin: unset !important;
}

.BC-Page__MerchandisingV2-Rule .merchandising-draggable .consequence-detail-title .title {
  align-items: center;
  text-align: center;
}

.BC-Page__MerchandisingV2-Rule .merchandising-draggable .BC-MerchandisingV2__Attributes-Table>.Polaris-Stack {
  margin: unset;
  border-radius: unset;
}

.BC-Page__MerchandisingV2-Rule .merchandising-draggable .consequence-detail-title .drag-icon .Polaris-Icon,
.BC-Page__MerchandisingV2-Rule .merchandising-draggable .consequence-detail-title .drag-icon .Polaris-Icon svg {
  width: 24px !important;
  height: 24px !important;
}

.BC-Page__MerchandisingV2-Rule .merchandising-draggable .consequence-detail-title .title .group-number {
  padding: 2px 4px !important;
}

.BC-Page__MerchandisingV2-Rule .merchandising-rule-settings .consequence-detail-title .Polaris-Icon,
.BC-Page__MerchandisingV2-Rule .merchandising-rule-strategy .consequence-detail-title .title .Polaris-Icon,
.BC-MerchandisingV2-Rule-save-modal .consequence-detail-title .Polaris-Icon {
  border: solid 1px var(--p-icon-subdued);
  border-radius: 0.25rem;
  padding: 4px;
  margin-right: 0.5rem;
}

.BC-Page__MerchandisingV2-Rule .merchandising-rule-settings .consequence-detail-title-banner .Polaris-Icon,
.merchandising-rule-strategy .consequence-detail-title .title-banner .Polaris-Icon,
.BC-MerchandisingV2-Rule-save-modal .consequence-detail-title-banner .Polaris-Icon {
  padding: 2px 4px !important;
}

.consequence-detail-title .Polaris-TextStyle--variationSubdued {
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  align-items: center;
  display: flex;
}

.consequence-detail-title .Polaris-TextStyle--variationSubdued>span {
  width: 100%;
  max-width: 212px;
}

.BC-MerchandisingV2-Rule-save-modal .consequence-detail-title .merchandising-rule-settings .consequence-detail-title {
  width: 13px;
  height: 13px;
  position: relative;
}

.BC-Page__MerchandisingV2-Rule .merchandising-rule-settings .consequence-detail-title .Polaris-Icon,
.BC-Page__MerchandisingV2-Rule .merchandising-rule-strategy .consequence-detail-title .title .Polaris-Icon,
.BC-Page__MerchandisingV2-Rule .consequence-detail-title .title .Polaris-Icon {
  width: 1.375rem;
  height: 1.375rem;
}

.BC-Page__MerchandisingV2-Rule .consequence-detail-content p,
.BC-MerchandisingV2-Rule-save-modal .consequence-detail-content p {
  margin-top: 0.5rem;
}

.BC-Page__MerchandisingV2-Rule .consequence-detail-content p:first-child,
.BC-Page__MerchandisingV2-Rule .consequence-detail-content div:first-child,
.BC-MerchandisingV2-Rule-save-modal .consequence-detail-content p:first-child {
  margin-top: 0.375rem;
}

.BC-MerchandisingV2-Rule-save-modal .consequence-detail-title .Polaris-Icon {
  width: 1.375rem;
  height: 1.375rem;
}

.BC-MerchandisingV2__Attributes-Table .Polaris-Stack--vertical {
  margin-top: 10px;
  flex-wrap: nowrap;
  background: #f6f6f7;
  border-radius: 6px;
  padding: 5px 10px 15px 10px;
}

.BC-MerchandisingV2__Attributes-Table .Polaris-Stack--vertical .Polaris-Stack__Item {
  margin-top: 20px;
}

.BC-MerchandisingV2__Attribute .groupFields-flex {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  margin-left: -1rem;
}

.BC-MerchandisingV2__Attribute .groupFields-flex>div {
  max-width: 30%;
  flex: 1 0 30%;
  padding-left: 1rem;
}

.BC-MerchandisingV2__Attribute .groupFields-flex-3>div:last-child {
  max-width: 40%;
  flex: 1 0 40%;
}

.BC-MerchandisingV2__Attribute .groupFields-flex-4>div:nth-child(3) {
  max-width: 37%;
  flex: 1 0 auto;
}

.BC-MerchandisingV2__Attribute .groupFields-flex .Polaris-TextField input {
  width: 2px;
}

@media (max-width: 46.5em) {
  .BC-MerchandisingV2__Attribute .groupFields-flex-4>div:nth-child(3) {
    max-width: 32%;
  }
}

.BC-MerchandisingV2__Attribute .groupFields-flex-4>button {
  margin: 0;
  padding: 0;
}

.BC-MerchandisingV2__Attribute .Polaris-FormLayout__Item:last-child {
  margin-top: 0;
}

.BC-MerchandisingV2__Attribute .wrap-attribute-field {
  display: inline-flex;
  width: 100%;
  margin-top: 0.75rem;
}

.BC-MerchandisingV2__Attribute .wrap-attribute-field .attribute-conductor input,
.BC-MerchandisingV2__Attribute .wrap-attribute-field .attribute-conductor button,
.BC-MerchandisingV2__Attribute .wrap-attribute-field .attribute-field input {
  border: none;
  border-color: white !important;
  box-shadow: none !important;
}

.BC-MerchandisingV2__Attribute .wrap-attribute-field .attribute-field button,
.BC-MerchandisingV2__Attribute .wrap-attribute-field .attribute-field div {
  border: none;
}

.BC-MerchandisingV2__Attribute .wrap-attribute-field .attribute-field>div>div:first-child {
  border: 1px solid #c9cccf !important;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}

.BC-MerchandisingV2__Attribute .attribute-conductor .one-option .Polaris-Select__Icon {
  visibility: hidden;
}

.BC-MerchandisingV2__Attribute .wrap-attribute-field .attribute-conductor .Polaris-Select--disabled .Polaris-Select__Content {
  color: rgba(32, 33, 35, 1);
}

.BC-MerchandisingV2__Attribute .wrap-attribute-field .Polaris-TextField__Backdrop::after,
.BC-MerchandisingV2__Attribute .wrap-attribute-field .Polaris-Select__Backdrop::after {
  box-shadow: none;
}

.BC-MerchandisingV2__Attribute .attribute-conductor {
  width: 30%;
  min-width: 90px;
}

.BC-MerchandisingV2__Attribute .attribute-conductor>div {
  border-top: 1px solid #c9cccf !important;
  border-left: 1px solid #c9cccf !important;
  border-bottom: 1px solid #c9cccf !important;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

.BC-MerchandisingV2__Attribute .date-select .field-error-text,
.BC-MerchandisingV2__Attribute .date-select .Polaris-Labelled__LabelWrapper {
  display: none;
}

.BC-MerchandisingV2__Attribute .render-queries-field {
  margin-left: 10px;
}

.BC-MerchandisingV2__Attribute .Polaris-Link {
  display: inline-flex;
}

.BC-MerchandisingV2__Attribute .Polaris-Link .Polaris-Icon {
  width: 16px;
  height: 16px;
  margin-left: 4px;
}

.BC-MerchandisingV2__Attribute .border-connect-input {
  width: 10px;
  height: 2rem;
  border-bottom: 1px solid #c9cccf;
  border-left: 1px solid #c9cccf;
}

.BC-MerchandisingV2__Attribute .attribute-conductor .Polaris-Select__Content {
  background-color: #edeeef;
}

.BC-MerchandisingV2__Attribute .attribute-field {
  width: 70%;
}

.BC-Page__MerchandisingV2-Rule .Polaris-Product-Tooltip-TooltipOverlay__Content {
  width: 10.8rem;
  padding: 1.25rem;
}

.BC-Page__MerchandisingV2-Rule .preview .productRow .productItem .product-image--no-image {
  background-color: #f4f6f8;
}

.BC-Page__MerchandisingV2-Rule .Polaris-Product-Tooltip-TooltipOverlay__Content .product-image,
.BC-Page__MerchandisingV2-Rule .preview .productRow .productItem .product-image {
  position: relative;
  height: 193px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}

.BC-Page__MerchandisingV2-Rule .Polaris-Product-Tooltip-TooltipOverlay__Content .product-image a,
.BC-Page__MerchandisingV2-Rule .preview .productRow .productItem .product-image a {
  display: none;
}

.BC-Page__MerchandisingV2-Rule .Polaris-Product-Tooltip-TooltipOverlay__Content .product-image:hover a,
.BC-Page__MerchandisingV2-Rule .preview .productRow .productItem .product-image:hover a {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: block;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3));
}

.BC-Page__MerchandisingV2-Rule .Polaris-Product-Tooltip-TooltipOverlay__Content .product-image a>span,
.BC-Page__MerchandisingV2-Rule .preview .productRow .productItem .product-image a>span {
  position: absolute;
  bottom: 40%;
  right: 0;
  left: 0;
  text-align: center;
}

.BC-Page__MerchandisingV2-Rule .Polaris-Product-Tooltip-TooltipOverlay__Content .product-image a .Polaris-Icon,
.BC-Page__MerchandisingV2-Rule .preview .productRow .productItem .product-image a .Polaris-Icon {
  width: 1.5625rem;
  height: 1.5625rem;
}

.BC-Page__MerchandisingV2-Rule .Polaris-Product-Tooltip-TooltipOverlay__Content .product-image a .Polaris-Icon,
.BC-Page__MerchandisingV2-Rule .preview .productRow .productItem .product-image a .Polaris-Icon {
  fill: white;
}

.BC-Page__MerchandisingV2-Rule .Polaris-Product-Tooltip-TooltipOverlay__Content .product-image a .view-product,
.BC-Page__MerchandisingV2-Rule .preview .productRow .productItem .product-image a .view-product {
  margin-top: 0.5rem;
  color: white;
  font-weight: 500;
}

.BC-Page__MerchandisingV2-Rule .Polaris-Product-Tooltip-TooltipOverlay__Content label {
  margin-top: 0.5rem;
  display: block;
}

/* MerchandisingV2 Preview */
.BC-Page__MerchandisingV2-Rule .preview {
  font-size: 0.875rem;
  margin-top: 24px;
}

.BC-Page__MerchandisingV2-Rule .preview .productGrid {
  font-weight: 600;
  font-size: 1rem;
  margin: 0 0 1.25rem;
  width: 100%;
}

.BC-Page__MerchandisingV2-Rule .preview .productGrid .pagination {
  margin-top: -1.25rem;
}

.BC-Page__MerchandisingV2-Rule .preview .productGrid .pagination .icon {
  border: 1px solid #c9cccf;
  border-radius: 6px;
  width: 26px;
  height: 26px;
  padding: 4px;
}

.BC-Page__MerchandisingV2-Rule .preview .productGrid .pagination .icon:not(:last-child) {
  margin-right: 6px;
}

.BC-Page__MerchandisingV2-Rule .preview .productGrid .pagination .disabled {
  background-color: #edeeef;
  opacity: 0.5;
}

.BC-Page__MerchandisingV2-Rule .preview .productGrid .pagination .item {
  min-width: 24px;
  padding: 2px;
  text-align: center;
  border: 1px solid #c9cccf;
  border-radius: 6px;
  margin-right: 6px;
  font-weight: 400;
  font-size: 0.875rem;
}

.BC-Page__MerchandisingV2-Rule .preview .productGrid .pagination .selected {
  background-color: #202123;
  color: #fff;
}

.BC-Page__MerchandisingV2-Rule .preview .productGrid .pagination .link {
  cursor: pointer;
}

.BC-Page__MerchandisingV2-Rule .preview .productGrid .pagination .point {
  border: none;
}

.BC-Page__MerchandisingV2-Rule .preview .noResult {
  margin-top: 2.5rem;
  text-align: center;
}

.BC-Page__MerchandisingV2-Rule .preview .noResult img {
  width: 50px;
}

.BC-Page__MerchandisingV2-Rule .preview .noResult .content {
  font-size: 1.25rem;
  padding-top: 1.25rem;
}

.BC-Page__MerchandisingV2-Rule .preview .productList .productRow {
  display: inline-flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-bottom: 1.25rem;
  width: 100%;
}

.BC-Page__MerchandisingV2-Rule .preview .productList .productItem {
  position: relative !important;
}

.BC-Page__MerchandisingV2-Rule .preview .productList .productItem .pin {
  position: absolute;
  top: 10px;
  right: 6px;
  width: 0.8rem;
  z-index: 2;
}

.BC-Page__MerchandisingV2-Rule .preview .productList .productItem {
  width: 22%;
  margin-bottom: 20px;
  min-width: 100px;
}

.BC-Page__MerchandisingV2-Rule .preview .productList .bannerItem {
  min-height: 274px;
}

.BC-Page__MerchandisingV2-Rule .preview .productList .productItem .noImage {
  width: 100%;
}

.BC-Page__MerchandisingV2-Rule .preview .productList .productItem .image {
  width: auto;
  height: auto;
  max-height: 193px;
  max-width: 100%;
}

.BC-Page__MerchandisingV2-Rule .preview .productList .productItem .title {
  font-size: 14px;
  line-height: 20px;
  height: 45px;
  margin: 8px 0px;
  display: inline-block;
  -webkit-line-clamp: 2;
  display: -webkit-box;
  line-height: 1.65;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.BC-Page__MerchandisingV2-Rule .preview .productList .productItem .priceMin {
  color: #d72c0d;
}

.BC-Page__MerchandisingV2-Rule .preview .productList .productItem .comparedAtPrice {
  color: #8c9196;
  text-decoration: line-through;
  margin-left: 5px;
}

.BC-Page__MerchandisingV2-Rule .pagination {
  display: flex;
  justify-content: flex-end;
  margin-top: 1.5rem;
  margin-bottom: 1.25rem;
  width: 100%;
}

.BC-MerchandisingV2-Rule-save-modal,
.BC-MerchandisingV2-Rule-save-modal .Polaris-Layout {
  min-height: 250px;
  max-height: 400px;
  height: 100%;
}

.BC-MerchandisingV2-Rule-save-modal .Polaris-Layout .Polaris-Layout__Section {
  margin-top: 20px;
}

.BC-MerchandisingV2-Rule-save-modal .Summarize-Date-Range {
  font-size: 16px;
  line-height: 20px;
  margin-top: 8px;
}

.BC-MerchandisingV2-Rule-save-modal .Polaris-DisplayText {
  font-weight: 400;
  font-size: 28px;
  line-height: 32px;
}

.BC-MerchandisingV2-Rule-save-modal .Polaris-Heading {
  font-size: 16px;
}

.BC-MerchandisingV2-Rule-save-modal .consequence-detail .consequence-detail-content p {
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
}

.Feature-Rule p {
  margin-top: 8px;
}

.BC-MerchandisingV2-Rule-save-modal .Feature-Title-Rule {
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  margin-top: 8px;
}

.Feature-Rule .Feature-Content-Rule p {
  font-size: 14px;
  line-height: 20px;
  color: #202223;
}

.Feature-Rule p span {
  font-weight: 500;
}

.Feature-Rule .Feature-Content-Rule--last {
  margin-bottom: 1.0625rem;
}

.Condition-Modal-Pick-apply-rule {
  display: flex;
  justify-content: flex-start;
  width: 100%;
  margin: 0.9375rem 0;
}

.Polaris-Modal__BodyWrapper .merchandisingV2-rule-condition-modal .Polaris-Heading,
.Polaris-Modal__BodyWrapper .condition-scope-layout .Polaris-Heading {
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
}

/* ReviewsIO x Boost */
.warningIntegration-container {
  margin-top: 12px;
  padding: 12px;
  background-color: #fff5ea;
  border: 2px solid #e1b878;
  border-radius: 4px;
  font-weight: 400;
  line-height: 20px;
  display: inline-block;
}

.warningIntegration-link {
  display: inline-block;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
}

.warningIntegration-link>button {
  display: inline-flex;
  color: #2c6ecb;
  text-decoration: none;
  align-items: center;
}

.warningIntegration-link>button>span {
  margin: 0;
  vertical-align: bottom;
}

.warningIntegration-link>button:hover,
.warningIntegration-link>button:focus {
  color: rgba(31, 81, 153, 1);
}

.warningIntegration-link svg {
  fill: #2c6ecb;
}

.warningIntegration-link>button:hover svg,
.warningIntegration-link>button:focus svg {
  fill: rgba(31, 81, 153, 1);
}`, "",{"version":3,"sources":["webpack://./src/styles/merchandising.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,4BAA4B;AAC9B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,8DAA8D;EAC9D,mBAAmB;AACrB;;AAEA;EACE,mDAAmD;AACrD;;AAEA;;;;EAIE,UAAU;AACZ;;AAEA;;;;EAIE,aAAa;EACb,QAAQ;AACV;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;;;;;EAKE,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;AACpB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,wBAAwB;EACxB,UAAU;EACV,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,mDAAmD;EACnD,oDAAoD;AACtD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,MAAM;AACR;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;;EAEX,iBAAiB;AACnB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,wCAAwC;EACxC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;EACf,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,8BAA8B;EAC9B,SAAS;EACT,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;;;;EAKE,aAAa;EACb,QAAQ;AACV;;AAEA;;;;;;EAME,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;AACd;;;AAGA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;EAGE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;;EAEE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,0BAA0B;AAC5B;;AAEA;;EAEE,aAAa;EACb,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,0CAA0C;EAC1C,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,4CAA4C;EAC5C,WAAW;AACb;;AAEA;EACE,QAAQ;EACR,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;EAEE,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;;;EAGE,oBAAoB;EACpB,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;EACxC,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;EACE,gDAAgD;EAChD,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;;EAEE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;;EAGE,uCAAuC;EACvC,sBAAsB;EACtB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;;;EAGE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;;EAGE,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;;EAGE,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,mBAAmB;AACrB;;AAEA;;;EAGE,YAAY;EACZ,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,wCAAwC;EACxC,yCAAyC;EACzC,2CAA2C;EAC3C,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,cAAc;EACd,yEAAyE;AAC3E;;AAEA;;EAEE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,OAAO;EACP,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,8BAA8B;EAC9B,eAAe;EACf,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;AACb;;AAEA;;EAEE,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,WAAW;EACX,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,sBAAsB;AACxB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,0BAA0B;AAC5B","sourcesContent":[".BC-Page__MerchandisingV2 .BC-Filters {\n  position: relative;\n}\n\n.BC-Page__MerchandisingV2 .BC-Filters .BC-Filters-ConnectedFilterControl {\n  display: flex;\n  flex-grow: 1;\n  gap: 10px;\n}\n\n.BC-Page__MerchandisingV2 .BC-Filters .BC-Filters-ConnectedFilterControl__CenterContainer {\n  min-width: 6.25rem;\n  display: flex;\n}\n\n.BC-Page__MerchandisingV2 .BC-Filters .BC-Filters-ConnectedFilterControl__RightContainer {\n  margin-left: 0.5rem;\n  flex: 1 1 auto;\n}\n\n.BC-Page__MerchandisingV2 .BC-Filters .BC-Filters__TagsContainer {\n  padding-top: 0.5rem;\n}\n\n.BC-Popover__MerchandisingV2-Filters-Options {\n  min-width: 244px;\n}\n\n.BC-Popover__MerchandisingV2-Filters-Options .Polaris-ChoiceList ul {\n  display: flex;\n}\n\n.BC-Popover__MerchandisingV2-Filters-Market .Polaris-ChoiceList ul {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-top: 8px;\n}\n\n.BC-Page__MerchandisingV2 .Polaris-DataTable__Table .group_btn .Polaris-Button--plain svg {\n  fill: var(--p-icon);\n}\n\n.BC-Popover__MerchandisingV2-Filters-Options .Polaris-ChoiceList ul li {\n  margin-right: 1.25rem;\n}\n\n.BC-Popover__MerchandisingV2-Filters-EditColumn {\n  min-width: 12rem;\n}\n\n.Polaris-Popover__Wrapper .Polaris-Popover__Section {\n  padding: 20px;\n}\n\n.BC-Popover__MerchandisingV2-Filters-Options legend {\n  margin-bottom: 12px;\n}\n\n.BC-Popover__MerchandisingV2-Filters-Options legend,\n.BC-Popover__MerchandisingV2-Filters-Options .Polaris-Label__Text {\n  font-weight: 500;\n}\n\n.BC-Page__MerchandisingV2 .Polaris-Card .Polaris-Card__Section .noRules {\n  min-height: 370px;\n}\n\n.BC-Popover__MerchandisingV2-Filters-Options .breakLine,\n.BC-Popover__MerchandisingV2-Filters-Market .breakLine {\n  padding: 16px 0 0 0;\n  display: flex;\n  justify-content: space-between;\n}\n\n.BC-Popover__MerchandisingV2-Filters-Market .Polaris-Tag button {\n  display: flex;\n  align-items: center;\n  margin: unset;\n  text-align: right;\n  justify-content: flex-end;\n}\n\n.BC-Popover__MerchandisingV2-Filters-Market {\n  width: 210px;\n}\n\n.BC-Page__MerchandisingV2 .Polaris-DataTable__Cell {\n  padding: 1rem 4px;\n  white-space: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  vertical-align: middle;\n}\n\n.BC-Page__MerchandisingV2 .Polaris-DataTable__Table .Polaris-DataTable__Cell--ab-testing .disabled svg path {\n  fill: #babec3;\n}\n\n.BC-Page__MerchandisingV2 .Polaris-DataTable__Cell--header {\n  padding: 1rem 4px;\n  font-weight: 500;\n  border-bottom: 0.0625rem solid var(--p-divider);\n}\n\n.BC-Page__MerchandisingV2 .Polaris-DataTable__Cell--header p {\n  font-weight: 500;\n}\n\n.BC-Page__MerchandisingV2 .Polaris-DataTable__Cell--header p,\n.BC-Page__MerchandisingV2 .Polaris-DataTable__Cell> :first-child {\n  font-size: 14px;\n  line-height: 20px;\n}\n\n.Polaris-DataTable__Cell--consequences .Polaris-Icon--colorSubdued svg {\n  fill: var(--p-icon-disabled);\n}\n\n.BC-Page__MerchandisingV2 .Polaris-DataTable__Cell.Polaris-DataTable__Cell--status {\n  width: 6%;\n  padding: 18px 18px 18px 20px;\n}\n\n.BC-Page__MerchandisingV2 .Polaris-DataTable__Cell.Polaris-DataTable__Cell--status span:hover {\n  cursor: pointer;\n}\n\n.BC-Page__Merchandising .Polaris-DataTable__Cell.Polaris-DataTable__Cell--status .BC-Checkbox-Status {\n  margin: 0;\n}\n\n.BC-Page__MerchandisingV2 .Polaris-DataTable__Cell--status-locked .BC-Checkbox-Status input:checked+span {\n  background-color: var(--p-surface-neutral-disabled) !important;\n  cursor: not-allowed;\n}\n\n.BC-Page__MerchandisingV2 .Polaris-DataTable__Cell--status-locked .BC-Checkbox-Status input:checked+span::before {\n  background-color: var(--p-icon-disabled) !important;\n}\n\n.BC-Page__MerchandisingV2 .Polaris-DataTable__Cell.Polaris-DataTable__Cell--queries,\n.BC-Page__MerchandisingV2 .Polaris-DataTable__Cell.Polaris-DataTable__Cell--queries-disabled,\n.BC-Page__MerchandisingV2 .Polaris-DataTable__Cell.Polaris-DataTable__Cell--collections-disabled,\n.BC-Page__MerchandisingV2 .Polaris-DataTable__Cell.Polaris-DataTable__Cell--collections {\n  width: 26%;\n}\n\n.BC-Page__MerchandisingV2 .Polaris-DataTable__Cell.Polaris-DataTable__Cell--queries .locked-query,\n.BC-Page__MerchandisingV2 .Polaris-DataTable__Cell.Polaris-DataTable__Cell--queries-disabled .locked-query,\n.BC-Page__MerchandisingV2 .Polaris-DataTable__Cell.Polaris-DataTable__Cell--collections-disabled .locked-query,\n.BC-Page__MerchandisingV2 .Polaris-DataTable__Cell.Polaris-DataTable__Cell--collections .locked-query {\n  display: flex;\n  gap: 2px;\n}\n\n.BC-Page__MerchandisingV2 .Polaris-DataTable__Cell.Polaris-DataTable__Cell--collections-disabled .Polaris-Link,\n.BC-Page__MerchandisingV2 .Polaris-DataTable__Cell.Polaris-DataTable__Cell--queries-disabled .Polaris-Link {\n  color: #202223;\n}\n\n.BC-Page__MerchandisingV2 .Polaris-DataTable__Cell.Polaris-DataTable__Cell--strategies {\n  width: 20%;\n}\n\n.BC-Page__MerchandisingV2 tbody .Polaris-DataTable__Cell.Polaris-DataTable__Cell--strategies {\n  width: 20%;\n}\n\n.BC-Page__MerchandisingV2 tbody .Polaris-DataTable__Cell.Polaris-DataTable__Cell--market {\n  width: 18%;\n}\n\n.BC-Page__MerchandisingV2 .Polaris-DataTable__Cell.Polaris-DataTable__Cell--dateRange {\n  width: 20%;\n  padding: 24px 12px;\n}\n\n.Polaris-DataTable__Cell--strategies span .Polaris-Icon .icon-filter {\n  margin-top: 2px;\n}\n\n.BC-Page__MerchandisingV2 .Polaris-DataTable__Cell.Polaris-DataTable__Cell--ab-testing {\n  width: 20%;\n}\n\n.BC-Page__MerchandisingV2 .Polaris-DataTable__Cell.Polaris-DataTable__Cell--ab-testing>p,\n.BC-Page__MerchandisingV2 .Polaris-DataTable__Cell.Polaris-DataTable__Cell--ab-testing>div {\n  display: flex;\n  justify-content: center;\n}\n\n.BC-Page__MerchandisingV2 .Polaris-DataTable__Cell.Polaris-DataTable__Cell--dateRange .Polaris-Badge {\n  border-radius: 4px;\n}\n\n.BC-Page__MerchandisingV2 .Polaris-DataTable__Cell.Polaris-DataTable__Cell--actions {\n  width: 14%;\n  text-align: center;\n  padding-right: 12px;\n}\n\n.BC-Page__MerchandisingV2 .Polaris-DataTable__Cell.Polaris-DataTable__Cell--actions .Polaris-ButtonGroup--segmented {\n  justify-content: right;\n}\n\n.BC-Page__MerchandisingV2 .Polaris-DataTable__Cell.Polaris-DataTable__Cell--consequences .Polaris-Icon {\n  width: 1rem;\n  height: 1rem;\n}\n\n.BC-Page__MerchandisingV2 .Polaris-DataTable__Cell--strategies .Polaris-Icon--colorSubdued svg {\n  fill: #babec3;\n}\n\n.BC-EmptyRules__MerchandisingV2 img,\n.BC-EmptyRules__Metafield img,\n.BC-EmptyRules__CustomRangeSlider img,\n.BC-EmptyRules__CustomSorting img,\n.BC-EmptyRules__Product-Visibility img {\n  width: 50px;\n}\n\n.BC-EmptyRules__MerchandisingV2 {\n  min-height: 250px;\n}\n\n.BC-Page__Merchandising-FilterBar-ActiveDate {\n  color: var(--p-text-subdued);\n  font-weight: 400;\n}\n\n.BC-Page__MerchandisingV2-Rule .tooltip-highlight {\n  border-radius: 10px;\n  background-color: #a4e8f2;\n  padding: 0 5px 0 5px;\n}\n\n.BC-Page__MerchandisingV2-Rule .fullscreen-title {\n  display: flex;\n  justify-content: center;\n  flex-grow: 1;\n  margin-left: 300px;\n}\n\n/* Region: Merchandising rule */\n.BC-Page__MerchandisingV2-Rule .fullscreen-bar {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  padding-left: 1rem;\n  padding-right: 1rem;\n}\n\n.BC-Page__MerchandisingV2-Rule .merchandising-rule-strategy,\n.BC-Page__MerchandisingV2-Rule .merchandising-rule-body .merchandising-rule-settings {\n  /* isolation: isolate; */\n  width: 30%;\n  min-height: 980px;\n  background: #ffffff;\n  border: 1px solid #e1e3e5;\n  border-bottom-left-radius: var(--p-border-radius-2);\n  border-bottom-right-radius: var(--p-border-radius-2);\n}\n\n.BC-Page__MerchandisingV2-Rule .merchandising-rule-strategy>div {\n  min-height: 1000px;\n}\n\n.BC-Page__MerchandisingV2-Rule .Polaris-FullscreenBar {\n  position: fixed;\n  width: 100%;\n  top: 0;\n}\n\n.BC-Page__MerchandisingV2-Rule .merchandising-rule-body {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 3.5rem;\n}\n\n.BC-Page__MerchandisingV2-Rule .merchandising-rule-body .merchandising-rule-strategy .strategy-content {\n  margin: 0 10px;\n}\n\n.BC-Page__MerchandisingV2-Rule .merchandising-rule-body .merchandising-rule-strategy .strategy-content .card-section {\n  padding: 0px 20px 5px 0px;\n  width: 100%;\n}\n\n.merchandising-rule-body .merchandising-rule-strategy .strategy-content .BC-Toggle-Switch {\n  padding: 9px;\n}\n\n.merchandising-rule-body .merchandising-rule-strategy .strategy-content .Polaris-Banner {\n  margin: 9px;\n\n  padding: 8px 12px;\n}\n\n.BC-Page__MerchandisingV2-Rule .merchandising-rule-body .merchandising-rule-strategy .card-section,\n.BC-Page__MerchandisingV2-Rule .merchandising-rule-body .merchandising-rule-settings .card-section {\n  padding: 16px 20px 4px 20px;\n}\n\n.BC-Page__MerchandisingV2-Rule .merchandising-rule-body .merchandising-rule-strategy .card-banner-section {\n  padding: 16px 12px 4px 12px;\n}\n\n.BC-Page__MerchandisingV2-Rule .merchandising-rule-body .merchandising-rule-strategy .card-banner-section>div>div {\n  display: grid;\n  gap: 20px;\n}\n\n.BC-Page__MerchandisingV2-Rule .banner-group-settings .banner-title {\n  margin-top: 0px;\n  margin-bottom: 8px;\n  display: flex;\n  justify-content: space-between;\n}\n\n.BC-Page__MerchandisingV2-Rule .merchandising-rule-body .merchandising-rule-settings .market .market-note {\n  margin-top: 10px;\n  color: #6d7175;\n  margin-left: 20px;\n}\n\n.BC-Page__MerchandisingV2-Rule .merchandising-rule-body .merchandising-rule-settings .market .market-note .Polaris-Icon {\n  display: inline-flex;\n  vertical-align: top;\n}\n\n.BC-Page__MerchandisingV2-Rule .merchandising-rule-settings .set-rule-conditions .market .Polaris-Button {\n  width: 100%;\n}\n\n.BC-Page__MerchandisingV2-Rule .merchandising-rule-settings .set-rule-conditions .market .Polaris-Button__Content {\n  display: flex;\n  justify-content: space-between;\n  font-weight: 400;\n}\n\n.BC-Page__MerchandisingV2-Rule .banner-group-settings .banner-title .title {\n  display: flex;\n  gap: 3px;\n  font-size: 12px;\n  font-weight: 500;\n  color: #6d7175;\n}\n\n.BC-Page__MerchandisingV2-Rule .banner-group-settings .banner-settings {\n  padding: 12px;\n  border-radius: 8px;\n  background-color: #f6f6f7;\n}\n\n.BC-Page__MerchandisingV2-Rule .banner-group-settings .banner-image .Polaris-Link {\n  display: flex;\n  font-size: 14px;\n  line-height: 20px;\n  align-items: center;\n  margin-top: 5px;\n}\n\n.BC-Page__MerchandisingV2-Rule .banner-group-settings .banner-image .Polaris-Link .Polaris-Icon {\n  margin: unset;\n}\n\n.BC-Page__MerchandisingV2-Rule .banner-group-settings .banner-settings>div:not(:first-child) {\n  margin-top: 16px;\n}\n\n.BC-Page__MerchandisingV2-Rule .banner-group-settings .banner-image>p:last-child {\n  font-size: 12px;\n  line-height: 16px;\n  margin-top: 5px;\n  color: #6d7175;\n}\n\n.custom-dropzone-merchandising {\n  position: relative;\n}\n\n.custom-dropzone-merchandising .dropzone-content {\n  background: #e5effd;\n  padding: 4px 6px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #1f5199;\n  width: fit-content;\n  border-radius: 4px;\n  margin-left: auto;\n  margin-right: auto;\n  margin-bottom: 8px;\n}\n\n.custom-dropzone-merchandising .dropzone-image .image {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.custom-dropzone-merchandising button {\n  padding: unset;\n  width: 20px;\n  height: 20px;\n  position: absolute;\n  right: 8px;\n  top: 18px;\n}\n\n.custom-dropzone-merchandising .dropzone-image {\n  padding: 18px 8px;\n  display: flex;\n  justify-content: space-between;\n}\n\n.custom-dropzone-merchandising .dropzone-image .file-info {\n  display: grid;\n  gap: 3px;\n}\n\n.custom-dropzone-merchandising .dropzone-image .Polaris-Caption {\n  font-size: 12px;\n  color: #6d7175;\n  line-height: 16px;\n}\n\n.custom-dropzone-merchandising .dropzone-image .Polaris-Thumbnail>* {\n  max-height: unset;\n  height: auto;\n  width: auto;\n}\n\n.custom-dropzone-merchandising .Polaris-TextStyle--variationSubdued {\n  font-size: 12px;\n}\n\n.custom-dropzone-merchandising.uploaded-error .Polaris-DropZone {\n  color: #d82c0d;\n  size: 12px;\n  font-weight: 600;\n  min-height: 76px;\n  align-items: center;\n  background-color: #fff4f4;\n}\n\n.custom-dropzone-merchandising.uploaded-error .Polaris-DropZone--hasOutline:not(.Polaris-DropZone--isDisabled),\n.custom-dropzone-merchandising.uploaded-error .Polaris-DropZone--hasOutline:not(.Polaris-DropZone--isDisabled):hover::after {\n  border-color: #fd5749;\n}\n\n.custom-dropzone-merchandising.uploaded-error .Polaris-DropZone .dropzone-error {\n  text-align: center;\n  font-size: 12px;\n}\n\n.custom-dropzone-merchandising.uploaded-error .Polaris-DropZone .dropzone-error>p:first-child {\n  font-weight: 600;\n}\n\n.custom-dropzone-merchandising.uploaded-error .Polaris-DropZone .dropzone-error>p:last-child {\n  font-weight: 400 !important;\n}\n\n.BC-Page__MerchandisingV2-Rule .merchandising-rule-body .merchandising-rule-settings .merchandising-strategies {\n  border-top: 1px solid #e4e5e7;\n  margin-top: 15px;\n}\n\n.BC-Page__MerchandisingV2-Rule .merchandising-rule-body .merchandising-rule-strategy .card-section:last-child,\n.BC-Page__MerchandisingV2-Rule .merchandising-rule-body .merchandising-rule-settings .card-section:last-child {\n  box-shadow: unset;\n}\n\n.BC-Page__MerchandisingV2-Rule .merchandising-rule-body .merchandising-rule-settings .card-section>p {\n  color: #6d7175;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 20px;\n  margin-top: 2px;\n  margin-bottom: 1px;\n}\n\n.BC-Page__MerchandisingV2-Rule .merchandising-rule-body .merchandising-rule-strategy .wrap-attribute {\n  display: flex;\n}\n\n.BC-Page__MerchandisingV2-Rule .merchandising-rule-body .merchandising-rule-strategy .last-or-connector {\n  border-bottom: 1px solid #a4e8f2;\n  margin-bottom: 30px;\n}\n\n.BC-Page__MerchandisingV2-Rule .merchandising-rule-body .merchandising-rule-strategy .or-text .Polaris-TextStyle--variationStrong {\n  height: 20px;\n  padding-left: 5px;\n  padding-right: 5px;\n  border-radius: 10px;\n  background-color: #a4e8f2;\n}\n\n.BC-Page__MerchandisingV2-Rule .merchandising-rule-body .merchandising-rule-strategy .group-number {\n  width: auto;\n  min-width: 20px;\n  height: 20px;\n  border-radius: 4px;\n  border: 1px solid rgba(201, 204, 207, 1);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 5px;\n  font-size: 12px;\n  color: rgba(109, 113, 117, 1);\n  line-height: 16px;\n  font-weight: 500;\n}\n\n.BC-Page__MerchandisingV2-Rule .merchandising-rule-body .merchandising-rule-strategy .or-connector {\n  width: 10px;\n  margin-left: 10px;\n  border-left: 1px solid #a4e8f2;\n}\n\n.BC-Page__MerchandisingV2-Rule .merchandising-rule-body .merchandising-rule-strategy .wrap-attribute .first-connector {\n  border-top: 1px solid #a4e8f2;\n  margin-top: 15px;\n}\n\n.BC-Page__MerchandisingV2-Rule .merchandising-rule-body .merchandising-rule-strategy .card-add-field-attribute .or-connector {\n  border-bottom: 1px solid #a4e8f2;\n  margin-bottom: 20px;\n}\n\n.BC-Page__MerchandisingV2-Rule .merchandising-rule-settings .set-rule-conditions>div,\n.BC-Page__MerchandisingV2-Rule .merchandising-rule-settings .set-rule-conditions>div {\n  padding-top: 16px;\n}\n\n.BC-Page__MerchandisingV2-Rule .merchandising-rule-settings .set-rule-conditions .date-range {\n  display: flex;\n  align-items: end;\n  justify-content: space-between;\n  gap: 16px;\n  width: 100%;\n}\n\n.BC-Page__MerchandisingV2-Rule .merchandising-rule-settings .set-rule-conditions .date-range>div {\n  width: 50%;\n}\n\n.BC-Page__MerchandisingV2-Rule .merchandising-rule-settings .set-rule-conditions .default-text-style {\n  font-weight: 400 !important;\n}\n\n.BC-Page__MerchandisingV2-Rule\n  .merchandising-rule-settings\n  .set-rule-conditions\n  .premium-badge-crown,\n.BC-SelectMarketType-item .premium-badge-crown {\n  display: flex;\n  gap: 4px;\n}\n\n.BC-Page__MerchandisingV2-Rule\n  .merchandising-rule-settings\n  .set-rule-conditions\n  .premium-badge-crown\n  .Polaris-Badge,\n.BC-SelectMarketType-item .premium-badge-crown .Polaris-Badge {\n  background-color: #fff2d9;\n  border-radius: 4px;\n  padding: 3px 4px;\n}\n\n.BC-SelectMarketType-item .premium-badge-crown .Polaris-Badge > span,\n.set-rule-conditions .premium-badge-crown .Polaris-Badge > span {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.BC-SelectMarketType-item .Polaris-Link {\n  display: flex;\n  align-items: center;\n}\n\n.merchandising-rule-settings .set-rule-conditions .upgrade-plan-text .Polaris-Icon {\n  vertical-align: top;\n  display: inline-flex;\n}\n\n.merchandising-rule-settings .set-rule-conditions .Polaris-FormLayout__Item:has(.upgrade-plan-text) {\n  margin-top: 4px;\n}\n\n.BC-Page__MerchandisingV2-Rule .merchandising-rule-settings .set-rule-conditions .premium-badge-crown .Polaris-Badge img {\n  width: 14px;\n  height: auto;\n}\n\n.BC-Page__MerchandisingV2-Rule .merchandising-rule-body .set-rule-strategies-title .Polaris-Icon {\n  height: 0.8rem;\n  width: 0.8rem;\n  margin-top: 3px;\n}\n\n.BC-Page__MerchandisingV2-Rule .merchandising-rule-body .summary-title .title {\n  margin-left: 20px;\n}\n\n.BC-Page__MerchandisingV2-Rule .merchandising-rule-body .summary-title {\n  padding-top: 20px;\n  margin-left: -20px;\n  margin-right: -20px;\n  border-top: solid 1px #e4e5e7;\n}\n\n.BC-Page__MerchandisingV2-Rule .merchandising-rule-body .set-rule-strategies-title .title {\n  font-weight: 600;\n  color: #6d7175;\n}\n\n.BC-Page__MerchandisingV2-Rule .merchandising-rule-body .set-rule-strategies-title {\n  display: flex;\n  gap: 10px;\n  font-weight: 400;\n  font-size: 14px;\n  align-items: center;\n}\n\n.path-setup {\n  color: #2c6ecb;\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.path-setup:hover {\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.set-rule-conditions div ul li {\n  padding-top: 12px;\n}\n\n.BC-Page__MerchandisingV2-Rule .merchandising-rule-body .merchandising-rule-settings .title-bold-normal {\n  height: 56px;\n  display: flex;\n  align-items: center !important;\n}\n\n.BC-Page__MerchandisingV2-Rule .merchandising-rule-preview {\n  width: 50%;\n  padding: 15px 15px 0 15px;\n}\n\n.BC-Page__MerchandisingV2-Rule .merchandising-rule-preview .Polaris-Card {\n  height: 100%;\n}\n\n.BC-Page__MerchandisingV2-Rule .merchandising-rule-preview .Polaris-Card .Polaris-Card__Header {\n  padding: 24px 0;\n  border-bottom: 1px solid #f5f5f5;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.BC-Page__MerchandisingV2-Rule .merchandising-rule-preview .Polaris-Card .Polaris-Card__Header>div {\n  width: 100%;\n  padding: 0 54px;\n  text-align: center;\n}\n\n.merchandising-rule-preview .Polaris-Card .Polaris-Card__Header .preview-title {\n  font-size: 16px;\n  line-height: 24px;\n  font-weight: 600;\n  margin-bottom: 4px;\n}\n\n.merchandising-rule-preview .Polaris-Card .Polaris-Card__Header .preview-content {\n  color: #6D7175;\n}\n\n.merchandising-rule-preview .Polaris-Card .Polaris-Card__Header .preview-content-market {\n  display: inline-flex;\n  gap: 4px;\n  align-items: center;\n}\n\n.merchandising-rule-preview .Polaris-Card .Polaris-Card__Header .preview-option {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 8px;\n}\n\n.merchandising-rule-preview .Polaris-Card .Polaris-Card__Header .preview-option .Polaris-Select {\n  width: 204px;\n}\n\n.merchandising-rule-preview .Polaris-Card .Polaris-Card__Header .preview-option .preview-market div,\n.merchandising-rule-preview .Polaris-Card .Polaris-Card__Header .preview-option>div {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  text-align: start;\n}\n\n.merchandising-rule-preview .Polaris-Card .Polaris-Card__Header .preview-option .preview-market .Polaris-SkeletonDisplayText__DisplayText{\n  width: 100%;\n}\n\n.merchandising-rule-preview .Polaris-Card .Polaris-Card__Header .preview-content-market img {\n  width: 20px;\n  height: 20px;\n}\n\n.BC-Page__MerchandisingV2-Rule .merchandising-rule-preview .Polaris-Card .Polaris-Card__Header .Polaris-Heading {\n  height: 100%;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  box-shadow: inset 0px -1px 0px #f5f5f5;\n}\n\n.BC-Page__MerchandisingV2-Rule .merchandising-rule-preview .Polaris-Card .Polaris-Card__Section {\n  padding: 0 54px;\n}\n\n.merchandising-rule-preview .bannerItem .Polaris-Thumbnail {\n  width: 100%;\n  height: 100%;\n  border: unset;\n}\n\n.merchandising-rule-preview .bannerItem:hover {\n  cursor: pointer;\n}\n\n.merchandising-rule-preview .bannerItem .Polaris-Thumbnail img {\n  margin: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.merchandising-rule-preview .preview .product-loading {\n  margin-top: 54px;\n}\n\n.merchandising-rule-preview .preview .banner-status {\n  margin-bottom: 24px;\n}\n\n.merchandising-rule-preview .preview .banner-status .Polaris-Banner {\n  padding: 8px 16px;\n}\n\n.BC-Page__MerchandisingV2-Rule .tooltip {\n  margin-left: 7px;\n  margin-top: 3px;\n  width: 10px;\n}\n\n.BC-Page__MerchandisingV2-Rule .tooltip .Polaris-Icon {\n  width: 0.7rem;\n  height: 0.7rem;\n}\n\n.BC-Page__MerchandisingV2-Rule .merchandising-rule-strategy .card-section:first-child {\n  box-shadow: inset 0px -1px 0px #e1e3e5;\n}\n\n.BC-Page__MerchandisingV2-Rule .render-queries-field {\n  display: flex;\n  justify-content: space-between;\n}\n\n.BC-Page__MerchandisingV2-Rule .wrap-queries {\n  margin-left: 10px;\n}\n\n.BC-Page__MerchandisingV2-Rule .wrap-select {\n  margin-left: 10px;\n  display: flex;\n}\n\n.BC-Page__MerchandisingV2-Rule .wrap-select>div:nth-child(2) {\n  width: 100%;\n  margin-top: 14px;\n}\n\n.BC-Page__MerchandisingV2-Rule .wrap-select .Polaris-Select-2 {\n  margin-top: 0.75rem;\n  width: 100%;\n}\n\n.BC-Page__MerchandisingV2-Rule .BC-Collection-List__Values .wrap-select {\n  padding-top: 16px;\n  margin-top: 0;\n  position: relative;\n}\n\n.BC-Page__MerchandisingV2-Rule .BC-Collection-List__Values .wrap-select .Polaris-Select-2 {\n  margin-top: 0;\n  max-width: calc(100% - 38px);\n  padding-left: 10px;\n}\n\n.BC-Page__MerchandisingV2-Rule .BC-Collection-List__Values .wrap-select.wrap-select--disabled .Polaris-Select-2 {\n  max-width: 100%;\n}\n\n.BC-Page__MerchandisingV2-Rule .BC-Collection-List__Values .wrap-select .button {\n  margin-left: 8px;\n  display: inline-flex;\n  align-items: flex-start;\n  justify-content: center;\n}\n\n.BC-Page__MerchandisingV2-Rule .BC-Collection-List__Values .wrap-select .button .Polaris-Button {\n  position: relative;\n  top: 10px;\n}\n\n.BC-Page__MerchandisingV2-Rule .all-rule-note {\n  margin-top: 4px;\n  color: #6d7175;\n}\n\n.BC-Page__MerchandisingV2-Rule .border-connect-select {\n  width: 10px;\n  height: 2rem;\n  border-bottom: 1px solid #c9cccf;\n  border-left: 1px solid #c9cccf;\n}\n\n.BC-Page__MerchandisingV2-Rule .BC-Collection-List__Values .wrap-select .border-connect-select {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 36px;\n}\n\n\n.BC-Page__MerchandisingV2-Rule .BC-Collection-List__Values .btn-add-collection {\n  margin-top: 16px;\n  margin-left: 20px;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n}\n\n.BC-Page__MerchandisingV2-Rule .textfield-with-prefix {\n  margin-top: 0.75rem;\n}\n\n.BC-Page__MerchandisingV2-Rule .border-connect-input {\n  width: 10px;\n  height: 2rem;\n  border-bottom: 1px solid #c9cccf;\n}\n\n.BC-Page__MerchandisingV2-Rule .wrap-input .render-queries-field:not(:last-child) {\n  border-left: 1px solid #c9cccf;\n}\n\n.BC-Page__MerchandisingV2-Rule .wrap-input .render-queries-field:last-child .border-connect-input {\n  border-left: 1px solid #c9cccf;\n}\n\n.BC-Page__MerchandisingV2 .typeAllIcon .Polaris-Icon__Svg {\n  fill: #f48d32;\n}\n\n.BC-Page__MerchandisingV2 .typeAllIcon {\n  display: flex;\n  width: 0.8rem;\n  height: 0.8rem;\n}\n\n.BC-Page__MerchandisingV2 .wrapTypeAllIcon {\n  min-width: 2rem;\n  height: 1.5rem;\n  border-radius: 4px;\n  background-color: #fff5ea;\n  margin-left: 5px;\n  display: flex;\n  justify-content: center;\n  padding: 2px 10px;\n  align-items: center;\n  gap: 2px;\n  max-width: 77px;\n}\n\n.merchandising-date-picker-input .Polaris-TextField {\n  max-height: 36px;\n  height: auto;\n}\n\n.merchandising-date-picker-input .Polaris-TextField input {\n  display: flex;\n  align-items: center;\n}\n\n.merchandising-rule-settings .title-bold-normal {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 20px;\n  padding: 20px 20px !important;\n}\n\n.merchandising-rule-strategy .title-bold-normal {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n  padding: unset !important;\n}\n\n.BC-Page__MerchandisingV2-Rule-DateRange {\n  font-weight: normal;\n  color: rgb(118, 118, 118);\n}\n\n.BC-Page__MerchandisingV2 .noRules .Polaris-DataTable__Cell:not(:first-child) {\n  text-align: center;\n}\n\n.BC-Page__MerchandisingV2-Rule .Polaris-Layout,\n.BC-Page__MerchandisingV2-Rule .Polaris-Layout .Polaris-Layout__Section,\n.BC-Page__MerchandisingV2-Rule .Polaris-Layout__Section .Polaris-Card__Section .Polaris-FormLayout {\n  margin-top: 0;\n}\n\n.BC-Page__MerchandisingV2-Rule .Polaris-Layout__Section--secondary .Polaris-Layout__Section .Polaris-Card__Section:first-child {\n  margin-top: 20px;\n}\n\n.BC-Page__MerchandisingV2-Rule .Polaris-Layout__Section--secondary .Polaris-Layout__Section .Polaris-Card__Section {\n  margin-top: 21px;\n}\n\n.BC-Page__MerchandisingV2 .condition-scope {\n  margin-bottom: 0.25rem;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 16px;\n}\n\n.BC-MerchandisingV2__Attribute .Polaris-Labelled__LabelWrapper {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 20px;\n  margin-left: 10px;\n}\n\n.BC-MerchandisingV2__Attribute .Polaris-FormLayout .Polaris-FormLayout__Item:nth-child(2) {\n  margin-top: unset;\n}\n\n.BC-Page__MerchandisingV2-Rule .Polaris-Page .Polaris-Page__Content .Polaris-Layout .Polaris-Layout__Section {\n  height: 100%;\n}\n\n.BC-Page__MerchandisingV2-Rule .Polaris-Page .Polaris-Page__Content .Polaris-Layout .Polaris-Layout__Section .Polaris-Card .Polaris-Card__Header {\n  height: 3.75rem;\n  border-bottom: 1px solid rgb(233, 230, 230);\n}\n\n.BC-Page__MerchandisingV2-Rule .Polaris-Layout {\n  grid-auto-rows: 1fr;\n  align-items: stretch;\n  min-height: 800px;\n}\n\n.BC-Page__MerchandisingV2-Rule .Polaris-Scrollable .Polaris-Layout,\n.BC-Page__MerchandisingV2-Rule .setting-rule-layout .Polaris-Layout {\n  display: block !important;\n  min-height: unset;\n}\n\n.BC-Page__MerchandisingV2-Rule .Polaris-Scrollable .Polaris-Layout .Polaris-Layout__Section .Polaris-Card__Section .Polaris-Heading {\n  font-size: 16px;\n  line-height: 24px;\n}\n\n.BC-Page__MerchandisingV2-Rule .Polaris-Layout .Polaris-Layout__Section .Polaris-Card {\n  height: 100%;\n}\n\n.BC-Page__MerchandisingV2-Rule .Polaris-Layout .Polaris-Layout__Section .Polaris-Card .Polaris-Layout .Polaris-Layout__Section .Polaris-Card__Section {\n  padding: 0rem 1.25rem;\n}\n\n.BC-Page__MerchandisingV2-Rule .Polaris-Layout .Polaris-Layout__Section .Polaris-Card .Polaris-Card__Header .Polaris-Heading {\n  font-size: 20px;\n  font-weight: 400;\n  line-height: 28px;\n}\n\n.BC-Page__MerchandisingV2-Rule .Polaris-Layout .Polaris-Layout__Section {\n  width: 100%;\n  height: inherit !important;\n}\n\n.BC-Page__MerchandisingV2-Rule .conditions,\n.BC-Page__MerchandisingV2-Rule .conditions-detail {\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n}\n\n.BC-Page__MerchandisingV2-Rule .condition-hover-all-content {\n  margin: 0rem -0.625rem -0.625rem -0.625rem;\n  padding: 0.625rem 0.625rem 0.625rem 0.625rem;\n}\n\n.BC-Page__MerchandisingV2-Rule .conditions-detail img {\n  width: 1.375rem;\n  height: 1.375rem;\n  margin-right: 0.5rem;\n}\n\n.BC-Page__MerchandisingV2-Rule .conditions-detail .Title_page_applied {\n  color: gray;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 16px;\n}\n\n.merchandising-condition-enable-search {\n  margin-top: 5px;\n  font-size: 14;\n  font-weight: 400;\n  max-width: 490px;\n  color: #f2711c;\n}\n\n.tooltip-enable-collection-search .Polaris-Tooltip-TooltipOverlay {\n  max-width: 254px;\n}\n\n.BC-Page__MerchandisingV2-Rule .conditions .strategy-btn {\n  width: 48%;\n  padding: 0;\n  margin-top: 1rem;\n}\n\n.BC-Page__MerchandisingV2-Rule .conditions .strategy-btn button {\n  width: 100%;\n}\n\n.BC-Page__MerchandisingV2-Rule .conditions .merchandising-lock-banner-btn button {\n  background-color: #ffc96b;\n  box-shadow: 0px -1px 0px 0px #00000033 inset;\n  border: 0px;\n}\n\n.BC-Page__MerchandisingV2-Rule .conditions button .Polaris-Button__Text {\n  gap: 4px;\n  display: flex;\n  align-items: center;\n}\n\n.BC-Page__MerchandisingV2-Rule .conditions .product-performance-ranking-btn {\n  width: 100%;\n}\n\n.BC-Page__MerchandisingV2-Rule .conditions .Polaris-Button__Content,\n.BC-Page__MerchandisingV2-Rule .Polaris-Layout .Polaris-FormLayout__Item .Polaris-Button__Content .Polaris-Button__Text {\n  font-weight: 500;\n  line-height: 20px;\n  font-size: 14px;\n}\n\n.BC-Page__MerchandisingV2-Rule .conditions-detail p,\n.BC-Page__MerchandisingV2-Rule .consequence-detail-content {\n  font-size: 14px !important;\n  line-height: 20px;\n}\n\n.BC-Page__MerchandisingV2-Rule .conditions-detail p span {\n  font-weight: 600;\n}\n\n.BC-Page__MerchandisingV2-Rule .consequence-add-button {\n  position: absolute;\n  top: '1px';\n  right: 0;\n}\n\n.BC-Page__MerchandisingV2-Rule .consequence-detail {\n  margin: -0.625rem;\n  padding: 0.625rem;\n}\n\n.BC-Page__MerchandisingV2-Rule .consequence-detail:hover {\n  background-color: var(--p-surface-hovered);\n  position: relative;\n}\n\n.BC-Page__MerchandisingV2-Rule .consequence-detail .consequence-detail-action {\n  position: absolute;\n  top: 0.625rem;\n  right: 0.625rem;\n  display: none;\n}\n\n.BC-Page__MerchandisingV2-Rule .consequence-detail .consequence-detail-action button {\n  margin-left: -0.25rem;\n}\n\n.BC-Page__MerchandisingV2-Rule .consequence-detail:hover .consequence-detail-action {\n  display: block;\n}\n\n.BC-Page__MerchandisingV2-Rule .tile-set-condition .tooltip .Polaris-Icon {\n  border: 0 !important;\n  padding: 2px !important;\n}\n\n.BC-Page__MerchandisingV2-Rule .tile-set-condition {\n  display: flex;\n  justify-content: space-between;\n}\n\n.BC-Page__MerchandisingV2-Rule .merchandising-rule-strategy .consequence-detail-title-tooltip .Polaris-Icon {\n  height: 0.75rem;\n  width: 0.75rem;\n  margin-top: 4px;\n}\n\n.BC-Page__MerchandisingV2-Rule .merchandising-rule-strategy .consequence-detail-header .title-header {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.merchandising-rule-strategy .consequence-detail-header .title-header p {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n  font-size: 16px;\n  font-weight: 600;\n  color: #6d7175;\n  max-width: 228px;\n}\n\n.BC-Page__MerchandisingV2-Rule .merchandising-rule-strategy .consequence-detail-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 20px 16px 20px !important;\n}\n\n.BC-Page__MerchandisingV2-Rule .merchandising-rule-strategy .consequence-detail-title-tooltip {\n  display: flex;\n  gap: 10px;\n}\n\n.BC-Page__MerchandisingV2-Rule .merchandising-rule-settings .consequence-detail-title,\n.BC-Page__MerchandisingV2-Rule .consequence-detail-title .title,\n.BC-MerchandisingV2-Rule-save-modal .consequence-detail-title {\n  display: inline-flex;\n  gap: 4px;\n}\n\n.BC-Page__MerchandisingV2-Rule .merchandising-rule-strategy .card-section:nth-child(3) .consequence-detail-title {\n  margin-top: 6px;\n}\n\n.BC-Page__MerchandisingV2-Rule .merchandising-rule-strategy .card-section .consequence-detail-title {\n  margin-bottom: 14px;\n  margin-top: 5px;\n}\n\n.merchandising-rule-settings .consequence-detail-title .Polaris-Icon svg,\n.merchandising-rule-strategy .consequence-detail-title .title .Polaris-Icon svg {\n  width: 100%;\n  height: auto;\n  position: relative;\n}\n\n.BC-Page__MerchandisingV2-Rule .merchandising-draggable .wrap-attribute .card-section {\n  border: 1px solid rgba(225, 227, 229, 1);\n  border-radius: 8px;\n  padding: unset !important;\n  margin: 8px 0;\n}\n\n.BC-Page__MerchandisingV2-Rule .merchandising-draggable .consequence-detail-title .drag-icon .Polaris-Icon {\n  border: unset !important;\n  margin-right: 8px !important;\n}\n\n.BC-Page__MerchandisingV2-Rule .merchandising-draggable .consequence-detail-title {\n  border-bottom: 1px dashed rgba(225, 227, 229, 1);\n  padding: 8px;\n  margin: unset !important;\n}\n\n.BC-Page__MerchandisingV2-Rule .merchandising-draggable .consequence-detail-title .title {\n  align-items: center;\n  text-align: center;\n}\n\n.BC-Page__MerchandisingV2-Rule .merchandising-draggable .BC-MerchandisingV2__Attributes-Table>.Polaris-Stack {\n  margin: unset;\n  border-radius: unset;\n}\n\n.BC-Page__MerchandisingV2-Rule .merchandising-draggable .consequence-detail-title .drag-icon .Polaris-Icon,\n.BC-Page__MerchandisingV2-Rule .merchandising-draggable .consequence-detail-title .drag-icon .Polaris-Icon svg {\n  width: 24px !important;\n  height: 24px !important;\n}\n\n.BC-Page__MerchandisingV2-Rule .merchandising-draggable .consequence-detail-title .title .group-number {\n  padding: 2px 4px !important;\n}\n\n.BC-Page__MerchandisingV2-Rule .merchandising-rule-settings .consequence-detail-title .Polaris-Icon,\n.BC-Page__MerchandisingV2-Rule .merchandising-rule-strategy .consequence-detail-title .title .Polaris-Icon,\n.BC-MerchandisingV2-Rule-save-modal .consequence-detail-title .Polaris-Icon {\n  border: solid 1px var(--p-icon-subdued);\n  border-radius: 0.25rem;\n  padding: 4px;\n  margin-right: 0.5rem;\n}\n\n.BC-Page__MerchandisingV2-Rule .merchandising-rule-settings .consequence-detail-title-banner .Polaris-Icon,\n.merchandising-rule-strategy .consequence-detail-title .title-banner .Polaris-Icon,\n.BC-MerchandisingV2-Rule-save-modal .consequence-detail-title-banner .Polaris-Icon {\n  padding: 2px 4px !important;\n}\n\n.consequence-detail-title .Polaris-TextStyle--variationSubdued {\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 16px;\n  align-items: center;\n  display: flex;\n}\n\n.consequence-detail-title .Polaris-TextStyle--variationSubdued>span {\n  width: 100%;\n  max-width: 212px;\n}\n\n.BC-MerchandisingV2-Rule-save-modal .consequence-detail-title .merchandising-rule-settings .consequence-detail-title {\n  width: 13px;\n  height: 13px;\n  position: relative;\n}\n\n.BC-Page__MerchandisingV2-Rule .merchandising-rule-settings .consequence-detail-title .Polaris-Icon,\n.BC-Page__MerchandisingV2-Rule .merchandising-rule-strategy .consequence-detail-title .title .Polaris-Icon,\n.BC-Page__MerchandisingV2-Rule .consequence-detail-title .title .Polaris-Icon {\n  width: 1.375rem;\n  height: 1.375rem;\n}\n\n.BC-Page__MerchandisingV2-Rule .consequence-detail-content p,\n.BC-MerchandisingV2-Rule-save-modal .consequence-detail-content p {\n  margin-top: 0.5rem;\n}\n\n.BC-Page__MerchandisingV2-Rule .consequence-detail-content p:first-child,\n.BC-Page__MerchandisingV2-Rule .consequence-detail-content div:first-child,\n.BC-MerchandisingV2-Rule-save-modal .consequence-detail-content p:first-child {\n  margin-top: 0.375rem;\n}\n\n.BC-MerchandisingV2-Rule-save-modal .consequence-detail-title .Polaris-Icon {\n  width: 1.375rem;\n  height: 1.375rem;\n}\n\n.BC-MerchandisingV2__Attributes-Table .Polaris-Stack--vertical {\n  margin-top: 10px;\n  flex-wrap: nowrap;\n  background: #f6f6f7;\n  border-radius: 6px;\n  padding: 5px 10px 15px 10px;\n}\n\n.BC-MerchandisingV2__Attributes-Table .Polaris-Stack--vertical .Polaris-Stack__Item {\n  margin-top: 20px;\n}\n\n.BC-MerchandisingV2__Attribute .groupFields-flex {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-start;\n  margin-left: -1rem;\n}\n\n.BC-MerchandisingV2__Attribute .groupFields-flex>div {\n  max-width: 30%;\n  flex: 1 0 30%;\n  padding-left: 1rem;\n}\n\n.BC-MerchandisingV2__Attribute .groupFields-flex-3>div:last-child {\n  max-width: 40%;\n  flex: 1 0 40%;\n}\n\n.BC-MerchandisingV2__Attribute .groupFields-flex-4>div:nth-child(3) {\n  max-width: 37%;\n  flex: 1 0 auto;\n}\n\n.BC-MerchandisingV2__Attribute .groupFields-flex .Polaris-TextField input {\n  width: 2px;\n}\n\n@media (max-width: 46.5em) {\n  .BC-MerchandisingV2__Attribute .groupFields-flex-4>div:nth-child(3) {\n    max-width: 32%;\n  }\n}\n\n.BC-MerchandisingV2__Attribute .groupFields-flex-4>button {\n  margin: 0;\n  padding: 0;\n}\n\n.BC-MerchandisingV2__Attribute .Polaris-FormLayout__Item:last-child {\n  margin-top: 0;\n}\n\n.BC-MerchandisingV2__Attribute .wrap-attribute-field {\n  display: inline-flex;\n  width: 100%;\n  margin-top: 0.75rem;\n}\n\n.BC-MerchandisingV2__Attribute .wrap-attribute-field .attribute-conductor input,\n.BC-MerchandisingV2__Attribute .wrap-attribute-field .attribute-conductor button,\n.BC-MerchandisingV2__Attribute .wrap-attribute-field .attribute-field input {\n  border: none;\n  border-color: white !important;\n  box-shadow: none !important;\n}\n\n.BC-MerchandisingV2__Attribute .wrap-attribute-field .attribute-field button,\n.BC-MerchandisingV2__Attribute .wrap-attribute-field .attribute-field div {\n  border: none;\n}\n\n.BC-MerchandisingV2__Attribute .wrap-attribute-field .attribute-field>div>div:first-child {\n  border: 1px solid #c9cccf !important;\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n}\n\n.BC-MerchandisingV2__Attribute .attribute-conductor .one-option .Polaris-Select__Icon {\n  visibility: hidden;\n}\n\n.BC-MerchandisingV2__Attribute .wrap-attribute-field .attribute-conductor .Polaris-Select--disabled .Polaris-Select__Content {\n  color: rgba(32, 33, 35, 1);\n}\n\n.BC-MerchandisingV2__Attribute .wrap-attribute-field .Polaris-TextField__Backdrop::after,\n.BC-MerchandisingV2__Attribute .wrap-attribute-field .Polaris-Select__Backdrop::after {\n  box-shadow: none;\n}\n\n.BC-MerchandisingV2__Attribute .attribute-conductor {\n  width: 30%;\n  min-width: 90px;\n}\n\n.BC-MerchandisingV2__Attribute .attribute-conductor>div {\n  border-top: 1px solid #c9cccf !important;\n  border-left: 1px solid #c9cccf !important;\n  border-bottom: 1px solid #c9cccf !important;\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n}\n\n.BC-MerchandisingV2__Attribute .date-select .field-error-text,\n.BC-MerchandisingV2__Attribute .date-select .Polaris-Labelled__LabelWrapper {\n  display: none;\n}\n\n.BC-MerchandisingV2__Attribute .render-queries-field {\n  margin-left: 10px;\n}\n\n.BC-MerchandisingV2__Attribute .Polaris-Link {\n  display: inline-flex;\n}\n\n.BC-MerchandisingV2__Attribute .Polaris-Link .Polaris-Icon {\n  width: 16px;\n  height: 16px;\n  margin-left: 4px;\n}\n\n.BC-MerchandisingV2__Attribute .border-connect-input {\n  width: 10px;\n  height: 2rem;\n  border-bottom: 1px solid #c9cccf;\n  border-left: 1px solid #c9cccf;\n}\n\n.BC-MerchandisingV2__Attribute .attribute-conductor .Polaris-Select__Content {\n  background-color: #edeeef;\n}\n\n.BC-MerchandisingV2__Attribute .attribute-field {\n  width: 70%;\n}\n\n.BC-Page__MerchandisingV2-Rule .Polaris-Product-Tooltip-TooltipOverlay__Content {\n  width: 10.8rem;\n  padding: 1.25rem;\n}\n\n.BC-Page__MerchandisingV2-Rule .preview .productRow .productItem .product-image--no-image {\n  background-color: #f4f6f8;\n}\n\n.BC-Page__MerchandisingV2-Rule .Polaris-Product-Tooltip-TooltipOverlay__Content .product-image,\n.BC-Page__MerchandisingV2-Rule .preview .productRow .productItem .product-image {\n  position: relative;\n  height: 193px;\n  text-align: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.BC-Page__MerchandisingV2-Rule .Polaris-Product-Tooltip-TooltipOverlay__Content .product-image a,\n.BC-Page__MerchandisingV2-Rule .preview .productRow .productItem .product-image a {\n  display: none;\n}\n\n.BC-Page__MerchandisingV2-Rule .Polaris-Product-Tooltip-TooltipOverlay__Content .product-image:hover a,\n.BC-Page__MerchandisingV2-Rule .preview .productRow .productItem .product-image:hover a {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  display: block;\n  background: linear-gradient(0deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3));\n}\n\n.BC-Page__MerchandisingV2-Rule .Polaris-Product-Tooltip-TooltipOverlay__Content .product-image a>span,\n.BC-Page__MerchandisingV2-Rule .preview .productRow .productItem .product-image a>span {\n  position: absolute;\n  bottom: 40%;\n  right: 0;\n  left: 0;\n  text-align: center;\n}\n\n.BC-Page__MerchandisingV2-Rule .Polaris-Product-Tooltip-TooltipOverlay__Content .product-image a .Polaris-Icon,\n.BC-Page__MerchandisingV2-Rule .preview .productRow .productItem .product-image a .Polaris-Icon {\n  width: 1.5625rem;\n  height: 1.5625rem;\n}\n\n.BC-Page__MerchandisingV2-Rule .Polaris-Product-Tooltip-TooltipOverlay__Content .product-image a .Polaris-Icon,\n.BC-Page__MerchandisingV2-Rule .preview .productRow .productItem .product-image a .Polaris-Icon {\n  fill: white;\n}\n\n.BC-Page__MerchandisingV2-Rule .Polaris-Product-Tooltip-TooltipOverlay__Content .product-image a .view-product,\n.BC-Page__MerchandisingV2-Rule .preview .productRow .productItem .product-image a .view-product {\n  margin-top: 0.5rem;\n  color: white;\n  font-weight: 500;\n}\n\n.BC-Page__MerchandisingV2-Rule .Polaris-Product-Tooltip-TooltipOverlay__Content label {\n  margin-top: 0.5rem;\n  display: block;\n}\n\n/* MerchandisingV2 Preview */\n.BC-Page__MerchandisingV2-Rule .preview {\n  font-size: 0.875rem;\n  margin-top: 24px;\n}\n\n.BC-Page__MerchandisingV2-Rule .preview .productGrid {\n  font-weight: 600;\n  font-size: 1rem;\n  margin: 0 0 1.25rem;\n  width: 100%;\n}\n\n.BC-Page__MerchandisingV2-Rule .preview .productGrid .pagination {\n  margin-top: -1.25rem;\n}\n\n.BC-Page__MerchandisingV2-Rule .preview .productGrid .pagination .icon {\n  border: 1px solid #c9cccf;\n  border-radius: 6px;\n  width: 26px;\n  height: 26px;\n  padding: 4px;\n}\n\n.BC-Page__MerchandisingV2-Rule .preview .productGrid .pagination .icon:not(:last-child) {\n  margin-right: 6px;\n}\n\n.BC-Page__MerchandisingV2-Rule .preview .productGrid .pagination .disabled {\n  background-color: #edeeef;\n  opacity: 0.5;\n}\n\n.BC-Page__MerchandisingV2-Rule .preview .productGrid .pagination .item {\n  min-width: 24px;\n  padding: 2px;\n  text-align: center;\n  border: 1px solid #c9cccf;\n  border-radius: 6px;\n  margin-right: 6px;\n  font-weight: 400;\n  font-size: 0.875rem;\n}\n\n.BC-Page__MerchandisingV2-Rule .preview .productGrid .pagination .selected {\n  background-color: #202123;\n  color: #fff;\n}\n\n.BC-Page__MerchandisingV2-Rule .preview .productGrid .pagination .link {\n  cursor: pointer;\n}\n\n.BC-Page__MerchandisingV2-Rule .preview .productGrid .pagination .point {\n  border: none;\n}\n\n.BC-Page__MerchandisingV2-Rule .preview .noResult {\n  margin-top: 2.5rem;\n  text-align: center;\n}\n\n.BC-Page__MerchandisingV2-Rule .preview .noResult img {\n  width: 50px;\n}\n\n.BC-Page__MerchandisingV2-Rule .preview .noResult .content {\n  font-size: 1.25rem;\n  padding-top: 1.25rem;\n}\n\n.BC-Page__MerchandisingV2-Rule .preview .productList .productRow {\n  display: inline-flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  margin-bottom: 1.25rem;\n  width: 100%;\n}\n\n.BC-Page__MerchandisingV2-Rule .preview .productList .productItem {\n  position: relative !important;\n}\n\n.BC-Page__MerchandisingV2-Rule .preview .productList .productItem .pin {\n  position: absolute;\n  top: 10px;\n  right: 6px;\n  width: 0.8rem;\n  z-index: 2;\n}\n\n.BC-Page__MerchandisingV2-Rule .preview .productList .productItem {\n  width: 22%;\n  margin-bottom: 20px;\n  min-width: 100px;\n}\n\n.BC-Page__MerchandisingV2-Rule .preview .productList .bannerItem {\n  min-height: 274px;\n}\n\n.BC-Page__MerchandisingV2-Rule .preview .productList .productItem .noImage {\n  width: 100%;\n}\n\n.BC-Page__MerchandisingV2-Rule .preview .productList .productItem .image {\n  width: auto;\n  height: auto;\n  max-height: 193px;\n  max-width: 100%;\n}\n\n.BC-Page__MerchandisingV2-Rule .preview .productList .productItem .title {\n  font-size: 14px;\n  line-height: 20px;\n  height: 45px;\n  margin: 8px 0px;\n  display: inline-block;\n  -webkit-line-clamp: 2;\n  display: -webkit-box;\n  line-height: 1.65;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.BC-Page__MerchandisingV2-Rule .preview .productList .productItem .priceMin {\n  color: #d72c0d;\n}\n\n.BC-Page__MerchandisingV2-Rule .preview .productList .productItem .comparedAtPrice {\n  color: #8c9196;\n  text-decoration: line-through;\n  margin-left: 5px;\n}\n\n.BC-Page__MerchandisingV2-Rule .pagination {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 1.5rem;\n  margin-bottom: 1.25rem;\n  width: 100%;\n}\n\n.BC-MerchandisingV2-Rule-save-modal,\n.BC-MerchandisingV2-Rule-save-modal .Polaris-Layout {\n  min-height: 250px;\n  max-height: 400px;\n  height: 100%;\n}\n\n.BC-MerchandisingV2-Rule-save-modal .Polaris-Layout .Polaris-Layout__Section {\n  margin-top: 20px;\n}\n\n.BC-MerchandisingV2-Rule-save-modal .Summarize-Date-Range {\n  font-size: 16px;\n  line-height: 20px;\n  margin-top: 8px;\n}\n\n.BC-MerchandisingV2-Rule-save-modal .Polaris-DisplayText {\n  font-weight: 400;\n  font-size: 28px;\n  line-height: 32px;\n}\n\n.BC-MerchandisingV2-Rule-save-modal .Polaris-Heading {\n  font-size: 16px;\n}\n\n.BC-MerchandisingV2-Rule-save-modal .consequence-detail .consequence-detail-content p {\n  font-size: 14px;\n  line-height: 20px;\n  font-weight: 400;\n}\n\n.Feature-Rule p {\n  margin-top: 8px;\n}\n\n.BC-MerchandisingV2-Rule-save-modal .Feature-Title-Rule {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  margin-top: 8px;\n}\n\n.Feature-Rule .Feature-Content-Rule p {\n  font-size: 14px;\n  line-height: 20px;\n  color: #202223;\n}\n\n.Feature-Rule p span {\n  font-weight: 500;\n}\n\n.Feature-Rule .Feature-Content-Rule--last {\n  margin-bottom: 1.0625rem;\n}\n\n.Condition-Modal-Pick-apply-rule {\n  display: flex;\n  justify-content: flex-start;\n  width: 100%;\n  margin: 0.9375rem 0;\n}\n\n.Polaris-Modal__BodyWrapper .merchandisingV2-rule-condition-modal .Polaris-Heading,\n.Polaris-Modal__BodyWrapper .condition-scope-layout .Polaris-Heading {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 20px;\n}\n\n/* ReviewsIO x Boost */\n.warningIntegration-container {\n  margin-top: 12px;\n  padding: 12px;\n  background-color: #fff5ea;\n  border: 2px solid #e1b878;\n  border-radius: 4px;\n  font-weight: 400;\n  line-height: 20px;\n  display: inline-block;\n}\n\n.warningIntegration-link {\n  display: inline-block;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n}\n\n.warningIntegration-link>button {\n  display: inline-flex;\n  color: #2c6ecb;\n  text-decoration: none;\n  align-items: center;\n}\n\n.warningIntegration-link>button>span {\n  margin: 0;\n  vertical-align: bottom;\n}\n\n.warningIntegration-link>button:hover,\n.warningIntegration-link>button:focus {\n  color: rgba(31, 81, 153, 1);\n}\n\n.warningIntegration-link svg {\n  fill: #2c6ecb;\n}\n\n.warningIntegration-link>button:hover svg,\n.warningIntegration-link>button:focus svg {\n  fill: rgba(31, 81, 153, 1);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
